// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:26:09.773Z
// Property: Eightyone10 Blue Goose (ID: 6767906449163351)
// Collections: 29 amenities, 8 floorplans (live), 29 photos, 82 POIs, 33 reviews, 3 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "6767906449163351",
  "property_external_id": "5383927",
  "property_zillow_url": "https://www.zillow.com/homedetails/8110-Blue-Goose-Rd-Manor-TX-78653/144269705_zpid/",
  "property_apartments_url": "https://www.apartments.com/eightyone10-blue-goose-manor-tx/14zyb76/",
  "property_google_business_url": "https://www.google.com/maps/place/EightyOne10+Blue+Goose/data=!4m2!3m1!1s0x0:0x822c12a3d8583467?sa=X&ved=2ahUKEwiarpOP4LySAxV7N0QIHcJOFQAQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "21798739084",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "eightyone10-blue-goose",
  "property_name": "Eightyone10 Blue Goose",
  "property_website_url": "https://www.eightyone10.com/",
  "property_domain": "https://www.eightyone10.com/",
  "property_address": "8110 Blue Goose Rd",
  "property_full_address": "8110 Blue Goose Rd, Manor, TX 78653",
  "property_address_1": "8110 Blue Goose Rd",
  "property_address_2": null,
  "property_address_city": "Manor",
  "property_address_state": "TX",
  "property_address_zip_full": "78653-2674",
  "property_address_zip": "78653",
  "property_address_country": "US",
  "property_address_county": "Travis County",
  "property_neighborhood_address": "Harris Branch",
  "property_address_latitude": "30.3387867",
  "property_address_longitude": "-97.60225589999999",
  "property_email": "eightyone10@alapts.com",
  "property_phone": "(737) 703-1750",
  "property_call_tracking_phone": "737-530-4261",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Manor living with room to spread out.</strong> Explore studio to three-bedroom apartments with polished finishes, smart everyday features, and resort-style spaces near US 290 and SH 130—then schedule your tour of Eightyone10 Blue Goose.</p>",
  "property_long_description": "<p><strong>Modern Manor living with room to spread out.</strong> At Eightyone10 Blue Goose, you’re just north of Wildhorse Ranch in the Harris Branch area, with quick access to US 290 and SH 130 for smoother connections across Northeast Austin, Manor, and the greater Austin corridor. Choose from <a href=\"/floor-plans\">studio, one-, two-, and three-bedroom layouts</a> designed with polished everyday details, including stainless steel appliances, Luna Pearl granite countertops, designer tile backsplashes, in-home washer and dryer, wood-style plank flooring, smart thermostats, USB outlets, and spacious closets.</p><p>Beyond your front door, the community brings the pace of a resort to everyday life with a <a href=\"/amenities\">pool with tanning deck</a>, poolside outdoor kitchen, outdoor game area, 24/7 fitness center, social clubroom, private work offices, package lockers, and a large leash-free bark park. When you’re ready to explore, local favorites like Good Luck Grill, Las Salsas, Jennie Lane Park, East Metropolitan Park, and the Austin-to-Manor Trail keep your <a href=\"/neighborhood\">Manor neighborhood</a> connected, convenient, and unmistakably Central Texas.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
    "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
    "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "300",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Administrative Fee $150\nApplication Approval Fee Starts at $300\nApplication Fee $75\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / month",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://9135150.onlineleasing.realpage.com/#k=38261",
  "property_resident_portal_url": "https://eightyone10bluegoose.loftliving.com/login",
  "property_apply_now_url": "https://9135150.onlineleasing.realpage.com/#k=38261",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e6a7c-3220-770a-8e34-16af50639ae1.webp",
  "property_primary_logo_media": {
    "alt_text": "Eighty One Ten Manor Texas Blue Goose logo",
    "public_id": "019e6a7c-3220-770a-8e34-16af50639ae1",
    "storage_key": "property/6767906449163351/019e6a7c-3220-770a-8e34-16af50639ae1.webp",
    "width": 3072,
    "height": 2731
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e6a7c-7b34-765d-93c8-7e2c1a3ec6ec.webp",
  "property_secondary_logo_media": {
    "alt_text": "Eighty One 10 Blue Goose logo",
    "public_id": "019e6a7c-7b34-765d-93c8-7e2c1a3ec6ec",
    "storage_key": "property/6767906449163351/019e6a7c-7b34-765d-93c8-7e2c1a3ec6ec.webp",
    "width": 3072,
    "height": 1075
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e6a7c-fa89-712f-8b5a-cc94609ef53f.webp",
  "property_icon_media": {
    "alt_text": "Goose Eighty One Blue logo",
    "public_id": "019e6a7c-fa89-712f-8b5a-cc94609ef53f",
    "storage_key": "property/6767906449163351/019e6a7c-fa89-712f-8b5a-cc94609ef53f.webp",
    "width": 3072,
    "height": 3072
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e6a7c-fa89-712f-8b5a-cc94609ef53f.webp",
  "property_fav_icon_media": {
    "alt_text": "Goose Eighty One Blue logo",
    "public_id": "019e6a7c-fa89-712f-8b5a-cc94609ef53f",
    "storage_key": "property/6767906449163351/019e6a7c-fa89-712f-8b5a-cc94609ef53f.webp",
    "width": 3072,
    "height": 3072
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e6a7c-009b-753d-a483-79fb600a40e2.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Eighty One 10 Blue Goose Manor Texas logo.",
    "public_id": "019e6a7c-009b-753d-a483-79fb600a40e2",
    "storage_key": "property/6767906449163351/019e6a7c-009b-753d-a483-79fb600a40e2.webp",
    "width": 3072,
    "height": 2731
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e6a7c-3220-770a-8e34-16af50639ae1.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Eighty One Ten Manor Texas Blue Goose logo",
    "public_id": "019e6a7c-3220-770a-8e34-16af50639ae1",
    "storage_key": "property/6767906449163351/019e6a7c-3220-770a-8e34-16af50639ae1.webp",
    "width": 3072,
    "height": 2731
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#31261d",
  "property_secondary_color": "#e8e5e0",
  "property_font_color": "#2e2a25",
  "property_color_4": "#afab9b",
  "property_color_3": "#6ea3cb",
  "property_color_5": "#bea48c",
  "property_color_6": "#f4c65c",
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "582 - 1580",
  "property_sqft_min": "582",
  "property_sqft_max": "1580",
  "property_price_range": "1161 - 2200.83",
  "property_price_min": "1161",
  "property_price_max": "2200.83",
  "property_available_units": 27,
  "property_facebook_url": "https://www.facebook.com/EightyOne10BlueGoose",
  "property_instagram_url": "https://www.instagram.com/eightyone10bluegoose/",
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/alta-blue-goose-by-wood-residential-manor",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities that keep pace.</strong> Shift from private work offices and a conference room to the 24/7 fitness center, then unwind by the resort-inspired pool, tanning deck, outdoor kitchen, and game area. At home, stainless steel appliances, Luna Pearl granite, under-cabinet lighting, smart thermostats, USB outlets, and in-home laundry bring everyday polish, with select private fenced yards, a leash-free bark park, and LuxerOne package services adding extra ease.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> Explore studio, one-, two-, and three-bedroom apartments in Manor with polished finishes like stainless steel appliances, Luna Pearl granite countertops, designer tile backsplash, wood-style plank flooring, in-home washer and dryer, smart thermostats, USB outlets, and generous closets. Select homes add private fenced yards for even more everyday flexibility.</p>",
  "property_home_gallery_blurb": "<p><strong>See Eightyone10 Blue Goose in focus.</strong> Preview bright Manor apartments with Luna Pearl granite, stainless steel appliances, tile backsplash, under-cabinet lighting, open living areas, generous closets, and select fenced yards. Then picture the extras outside your door: a resort-inspired pool with tanning deck, poolside outdoor kitchen, clubroom, fitness center, work spaces, game areas, and a large bark park. Browse the gallery and choose the spaces you want to see up close.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Manor momentum, Northeast Austin access.</strong> At Eightyone10 Blue Goose, everyday stops near Manor Crossing—including H-E-B—are close by, with US 290 and SH 130 connecting you across Austin. Map out breakfast at Cafe 290, fresh air near Ben E. Fisher Park, lake views at Walter E. Long Metropolitan Park, or miles on the Austin-to-Manor Trail.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents rave about the people and the place.</strong> Reviews for Eightyone10 Blue Goose highlight a friendly, responsive leasing team, smooth move-ins, and maintenance that’s quick to help. The community also earns praise for its modern apartments, clean amenity spaces, quiet atmosphere, and well-kept surroundings.</p><p>From the pool and spacious gym to the dog park and pet wash, see what makes daily life here so highly recommended.</p>",
  "property_neighborhood_blurb": "<p><strong>A Northeast Austin address with Manor momentum.</strong> From Harris Branch, you’re close to the everyday conveniences gathering around Manor Crossing, including the new H-E-B, while US 290 and SH 130 keep the wider Austin area easy to reach. Use the map to trace your own route: breakfast at Cafe 290, a picnic near Ben E. Fisher Park, lake views at Walter E. Long Metropolitan Park, or a ride along the Austin-to-Manor Trail, which links Manor to the Southern Walnut Creek trail system.</p><p>Back at Eightyone10 Blue Goose, neighborhood ease continues with <a href=\"/amenities\">community spaces</a> made for downtime between outings. When you’re ready to see how the location fits your routine, <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, inside and out.</strong> At Eightyone10 Blue Goose, your day can move from a focused work session in the private work offices or conference room to a workout in the 24/7 fitness center, then out to the resort-inspired pool, tanning deck, outdoor kitchen, and game area. Inside your apartment, polished finishes do the everyday heavy lifting: stainless steel appliances, a side-by-side refrigerator with in-door water and ice, Luna Pearl granite countertops, under-cabinet lighting, smart thermostats, USB outlets, and an in-home washer and dryer. Select homes add private fenced yards, while the large leash-free bark park and LuxerOne package services add extra ease. See how it all comes together in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at Eightyone10 Blue Goose.</strong><br>Modern studio, one-, two-, and three-bedroom layouts pair polished finishes with everyday convenience, from stainless steel appliances to in-home laundry and spacious closets. With easy access to US 290 and SH 130, applying online is a simple next step toward Manor living.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Connect with the leasing team at Eightyone10 Blue Goose to learn more about modern Manor apartments, spacious layouts, polished finishes, and convenient access to US 290 and SH 130. We’re here to help you plan your next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Eightyone10 Blue Goose?</strong> Find quick answers about the community, leasing, floor plans, features, and everyday living in Manor. If you need details beyond the FAQs, the leasing team is happy to help you get the information you need.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Eightyone10 Blue Goose gives you a clear range of studio, one-, two-, and three-bedroom apartments in Manor, from streamlined spaces with an easy everyday flow to larger homes with extra separation, two full baths, and room to spread out.</p><p>As you compare floor plan cards, look for the details that make each home feel polished from move-in: stainless steel appliances, Luna Pearl granite countertops, designer tile backsplash, wood-style plank flooring, in-home washer and dryer, smart thermostats, USB outlets, and generous closet space. Select homes add private fenced yards for even more flexibility. Browse current availability, check pricing, then explore the <a href=\"/amenities\">features and finishes</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the details before you arrive.</strong> In the Eightyone10 Blue Goose photo gallery, you can move from bright apartment interiors to polished shared spaces and see how the community feels frame by frame. Notice the kitchen shots with Luna Pearl granite, stainless steel appliances, tile backsplash, and under-cabinet lighting; then look for open living areas, spacious closets, and select fenced yards that add another layer of everyday flexibility.</p><p>Beyond your front door, the images bring the Manor setting into focus with a resort-inspired pool and tanning deck, poolside outdoor kitchen, social clubroom, fitness center, work spaces, game areas, and a large bark park. Browse the photos, compare the finishes with the full <a href=\"/amenities\">amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place on the map.</strong> Explore available apartments at Eightyone10 Blue Goose, then see how Harris Branch access, nearby Manor highlights, and quick connections to US 290 and SH 130 put Northeast Austin within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with room to roam.</strong> At Eightyone10 Blue Goose, cats and dogs can settle in with you in Manor, with a generous policy that includes no weight limit and space for up to two pets per home. Start the day at the large leash-free bark park, then head back to an apartment designed for easy everyday living with modern wood-style plank flooring, in-home washer and dryer, spacious closets, and select private fenced yards.</p><p>When you want to see how the lifestyle fits, explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to walk the community spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Eightyone10 Blue Goose?</strong> Share the modern Manor living, spacious layouts, polished apartment finishes, and resort-inspired community spaces with a friend. Send an invite today and help them discover the room, style, and everyday convenience you already enjoy.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong><br>At Eightyone10 Blue Goose, everyday living is designed to feel polished and connected. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to enjoying modern Manor living with more room to spread out.</p>",
  "property_reviews_blurb": "<p><strong>Resident feedback says it best:</strong> “Property is amazing and staff is great!” At Eightyone10 Blue Goose, reviews consistently point to a leasing team that is friendly, patient, and quick to help—from answering questions to sending videos and making move-ins feel seamless.</p><p>You’ll also see residents praising the beautiful, well-kept community, modern apartments, responsive maintenance, and clean amenity spaces. Favorites mentioned again and again include the pool, spacious gym, dog park, and pet wash area, along with a quiet atmosphere and easy everyday access. Browse the reviews below to see why so many residents describe their experience here as helpful, comfortable, and highly recommendable.</p>",
  "property_created_at": "1752257954138",
  "property_scheduletour_blurb": "<p><strong>See modern Manor living up close.</strong> Tour studio, one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with granite countertops, stainless steel appliances, wood-style plank flooring, smart thermostats, and spacious closets—then explore resort-style spaces made for everyday downtime. Schedule your visit to Eightyone10 Blue Goose today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The leasing team at Eightyone10 Blue Goose will be in touch soon. In the meantime, picture modern Manor living with polished finishes, spacious layouts, and resort-style community spaces—all with convenient access across Northeast Austin and the greater Austin corridor.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> The virtual tours at Eightyone10 Blue Goose let you move through the spaces that matter most, from the community tour to studio, one-, two-, and three-bedroom apartment walkthroughs in Manor. Compare open living areas, modern kitchens, bedroom placement, closet flow, and the way each layout feels from room to room—all from wherever you are.</p><p>Use the tours to narrow your favorites, then pair what you see with current <a href=\"/floor-plans\">floor plan availability</a> or the <a href=\"/gallery\">photo gallery</a>. When a space clicks, <a href=\"/schedule-a-tour\">schedule a tour</a> and experience Eightyone10 Blue Goose in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Eightyone10 Blue Goose",
  "property_seo_title_home": "Eightyone10 Blue Goose | Apartments in Manor, TX",
  "property_seo_description_home": "Discover your ideal living space at Eightyone10 Blue Goose in Manor, TX! Choose from spacious floor plans including studios, one, two, and three-bedroom apartments featuring modern amenities such as a resort-style pool, fitness center, and dog park. Enjoy the convenience of digital thermostats, covered parking, online resident services, and more! Embrace luxury living with upgraded kitchens and relaxing soaking tubs. Find your new home today and experience the perfect blend of comfort and style.",
  "property_seo_title_floorplans": "Floor Plans | studio - 3 Apartments in Manor, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Eightyone10 Blue Goose in Manor, TX! Explore our thoughtfully designed floor plans, including stylish one-bedroom, spacious two-bedroom, family-friendly three-bedroom, and cozy studio options. Browse our available apartment homes today and find the perfect floor plan that suits your lifestyle!",
  "property_seo_title_amenities": "Amenities | Manor, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover the perfect blend of comfort and convenience at Eightyone10 Blue Goose in Manor, TX. Explore our diverse floor plans, including studios, one, two, and three-bedroom apartments tailored to fit your lifestyle. Enjoy exceptional amenities like a resort-style pool, state-of-the-art fitness center, and a vibrant dog park. With features like digital thermostats, soaking tubs, and walk-in closets, your new home awaits! Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Manor, TX",
  "property_seo_description_gallery": "Explore the vibrant lifestyle at Eightyone10 Blue Goose in Manor, TX! Discover our diverse floor plans—choose from studios, one, two, and three-bedroom apartments—each designed for comfort and convenience. Enjoy top-notch amenities including a resort-style pool, state-of-the-art fitness center, and a dog park for your furry friends. Experience modern living with features like built-in refrigerators, digital thermostats, and W&D included. Picture yourself living here and get inspired by our photo gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | Eightyone10 Blue Goose Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Eightyone10 Blue Goose in Manor, TX! Explore our diverse floor plans, including studio, one, two, and three-bedroom options. Take a virtual tour today and imagine life in our vibrant community. Don’t miss out—your ideal apartment awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Eightyone10 Blue Goose Apartments",
  "property_seo_description_interactivemap": "Explore the vibrant lifestyle at Eightyone10 Blue Goose in Manor, TX! Discover our diverse floor plans, including studio, one, two, and three-bedroom apartments, designed to fit your needs. Enjoy exceptional amenities like a resort-style pool, fitness center, dog park, and a resident clubhouse. Use our interactive community map to find your ideal apartment, view pricing, and make Eightyone10 Blue Goose your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Manor, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Eightyone10 Blue Goose in Manor, TX! Explore our diverse floor plans, including one, two, and three-bedroom apartments, as well as cozy studios. Uncover local favorites and exciting points of interest. See what's around our community and start your journey today!",
  "property_seo_title_contact": "Contact Us | Eightyone10 Blue Goose",
  "property_seo_description_contact": "Discover your perfect home at Eightyone10 Blue Goose in Manor, TX! Explore our variety of spacious floor plans, including one-bedroom, two-bedroom, three-bedroom, and studio options designed for your lifestyle. Have questions? Contact our leasing team today for personalized assistance and make your dream apartment a reality!",
  "property_seo_title_faqs": "FAQs | Apartments in Manor, TX",
  "property_seo_description_faqs": "Discover everything you need to know about Eightyone10 Blue Goose in Manor, TX, on our FAQs page. Explore our diverse range of floor plans, including one-bedroom, two-bedroom, three-bedroom, and studio options, all equipped with modern amenities like a resort-style pool, fitness center, and dog park. Get answers to your questions about online resident services, covered parking, and more. Browse our FAQs to learn how our community can elevate your living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Manor, TX",
  "property_seo_description_reviews": "Explore Eightyone10 Blue Goose in Manor, TX, where modern living meets luxury amenities! Choose from our diverse floor plans, including one, two, and three-bedroom apartments and stylish studios. Enjoy vibrant community features like a resort-style pool, fitness center, dog park, and online resident services. Want to know more? Check out our resident reviews to see what living at Eightyone10 Blue Goose is really like!",
  "property_seo_title_applynow": "Apply Now | Apartments in Manor, TX",
  "property_seo_description_applynow": "Discover your perfect home at Eightyone10 Blue Goose in Manor, TX! Explore our stunning floor plans, including studios, one, two, and three-bedroom apartments designed for your lifestyle. Enjoy premium amenities like a resort-style pool, fitness center, dog park, and modern kitchens with top-notch appliances. With online resident services and a vibrant community atmosphere, your ideal living experience awaits. Don't wait - apply now and find your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Eightyone10 Blue Goose",
  "property_seo_description_residentaccess": "\"Log in to Eightyone10 Blue Goose's resident portal for easy access to rent payments, maintenance scheduling, and community updates in Manor, TX. Enjoy seamless living—access your portal now!\"",
  "property_seo_title_referafriend": "Refer A Friend | Eightyone10 Blue Goose",
  "property_seo_description_referafriend": "\"Discover vibrant living at Eightyone10 Blue Goose in Manor, TX! Refer a friend today and build a community of great neighbors. Enjoy exclusive perks for referrals and experience the ultimate in apartment living. Join us now!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Eightyone10 Blue Goose",
  "property_seo_description_scheduletour": "Discover your new home at Eightyone10 Blue Goose in Manor, TX! Schedule a tour today to explore our modern apartments and vibrant community features. Experience comfort and convenience in a setting you'll love!",
  "property_seo_title_privacy": "Privacy Policy | Eightyone10 Blue Goose",
  "property_seo_description_privacy": "Discover the commitment to your privacy at Eightyone10 Blue Goose in Manor, TX. Learn how we protect your personal information and ensure a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Eightyone10 Blue Goose",
  "property_seo_description_accessibility": "Discover the commitment to digital inclusion at Eightyone10 Blue Goose in Manor, TX. Explore our Accessibility Statement and learn how we ensure a welcoming and accessible experience for all residents. Join our vibrant community today!",
  "property_seo_title_sitemap": "Sitemap | Eightyone10 Blue Goose",
  "property_seo_description_sitemap": "Discover Eightyone10 Blue Goose in Manor, TX! Navigate our community effortlessly with our comprehensive sitemap. View all available amenities, floor plans, and key information to make your apartment search seamless. Explore now!",
  "property_seo_title_thankyou": "Thank You | Eightyone10 Blue Goose",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Eightyone10 Blue Goose in Manor, TX! Your information has been received, and our dedicated team will be in touch shortly to assist you in finding your perfect apartment home. Stay tuned for updates!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234321156",
  "amenities": [
    {
      "id": "custom_4538f051-9112-45b8-8f0b-ce2486620487",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Gorgeous Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ba3ee76-4bf1-47c6-ab16-484219895c84",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_01c222f9-7975-4ea0-8e47-27bfb1957120",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Modern Wood-Style Plank Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_37b5c93f-7f39-4fcb-ab23-e2240e74a620",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000680",
      "title": "Soaking Tub",
      "amount": "0.0000",
      "description": "Private en-suite Primary Bath w/Modern Tile + Shower Surrounds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76d5951c-e0b3-414e-bee6-30903b65096d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Designer Ceramic Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c016639-b7d2-4cd1-9290-b3f9f700133f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e7e02a5-fa59-440b-b081-200da67adcb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Spacious Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_294cc4b3-c6d6-48a3-8529-8391d723e6d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000002370",
      "title": "Built-In Refrigerator",
      "amount": "0.0000",
      "description": "Side-By-Side Refrigerator w/In-Door Water + Ice Dispenser",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5df52229-0fe3-4ea5-9558-2c0515a51e86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "Wood Style 2 Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ff49a6d-57ac-4000-a21d-6d91da0e1da9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Under Cabinet Lighting in Kitchen",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_145da69c-bfda-4fc5-b350-4933283a67bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Luna Pearl Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ecb39d83-dde9-4f47-9109-2e58431db23e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000625",
      "title": "Digital Thermostats",
      "amount": "0.0000",
      "description": "WiFi Programmable Thermostats",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a62eddb0-ab3a-47c7-94c2-49b05ff696b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000631",
      "title": "Fan",
      "amount": "0.0000",
      "description": "Ceiling Fans in Bedrooms + Living Room",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91461f6b-5c2e-4607-85f5-917f57667b95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000632",
      "title": "Fenced Yard",
      "amount": "0.0000",
      "description": "Private Fenced Yards*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6647835-53e8-4113-964f-9ad55a58b146",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3bdfe6b-4fef-49d1-a26b-1756092fdce8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000002405",
      "title": "Resort Style Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool w/Tanning Deck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02f16ebe-4d83-4f7f-9f4f-1713c36f02cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24/7 Fitness w/Modern Cardio Theater + TRX Escape Quad",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae2cfd9f-c7d3-48ea-b158-3f290860c817",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000639",
      "title": "Game Room",
      "amount": "0.0000",
      "description": "Outdoor Game & Entertainment Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3db5c77-0930-4ca7-91be-09adb4fd61cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Poolside Outdoor Kitchen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8484b477-750f-4684-9214-48375b0c871c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Large Leash-Free Bark Park",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2c926991-e1c2-4b25-a969-3b1c493d0909",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "LuxerOne Resident Package Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_30352b8c-8e50-4bfe-b36f-1a36d3529001",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Covered Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3bc246c-3cc0-4c40-998c-8b077ad086b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000002365",
      "title": "Conference Room",
      "amount": "0.0000",
      "description": "Private Work Offices + Conference Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_116fffda-091a-4acb-8a62-0fbf804ad5f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000002469",
      "title": "Wi-Fi Business Lounge",
      "amount": "0.0000",
      "description": "WiFi in Community Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b42dffa4-cc6b-4079-ae2d-68ab1bc535f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Social Clubroom w/Kitchen & TVs",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_938a72cc-2b92-4ec6-b911-82f6d968a69a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000002561",
      "title": "RentPlus",
      "amount": "0.0000",
      "description": "Credit Building powered by RentPlus",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eaba6d45-956a-4095-b3ca-912783aabf1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000002563",
      "title": "Spruce",
      "amount": "0.0000",
      "description": "Concierge Cleaning Services Available by Spruce",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a380891e-6358-4bdf-bc13-c3ce9ba51fc0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7378d329-28a1-4ad2-954e-682505d0b88b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8e1f7671-2b3e-4323-9a09-c8465aa6e6d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded cabanas for ultimate comfort.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0828e42c-1a39-4ada-b70e-46ab1fa800a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-989e-7595-a5a8-865f1ecc08df.webp",
      "image_media": {
        "alt_text": "Two Adirondack chairs and a cornhole game set up on artificial turf in front of apartment buildings.",
        "public_id": "019e8993-989e-7595-a5a8-865f1ecc08df",
        "storage_key": "property/6767906449163351/019e8993-989e-7595-a5a8-865f1ecc08df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor games and relaxation in the community's recreational area, complete with comfortable seating and a cornhole setup.",
      "link": "",
      "alt_text": "Two Adirondack chairs and a cornhole game set up on artificial turf in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_283dcc00-d449-49cc-a44d-2deb2330a1cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-97b9-7595-ba7d-40131d5a1d04.webp",
      "image_media": {
        "alt_text": "Fitness center with weight benches, dumbbells, treadmills, and a squat rack.",
        "public_id": "019e8993-97b9-7595-ba7d-40131d5a1d04",
        "storage_key": "property/6767906449163351/019e8993-97b9-7595-ba7d-40131d5a1d04.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio machines, weight training equipment, and free weights for a comprehensive workout.",
      "link": "",
      "alt_text": "Fitness center with weight benches, dumbbells, treadmills, and a squat rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_788b6973-f31e-4519-99cb-6faa9f87a706",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-8e68-770b-bf95-e5ef9ad56e91.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with modern architecture and manicured lawns.",
        "public_id": "019e8993-8e68-770b-bf95-e5ef9ad56e91",
        "storage_key": "property/6767906449163351/019e8993-8e68-770b-bf95-e5ef9ad56e91.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover modern apartment living with beautifully designed exteriors and lush green spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with modern architecture and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_def91b06-f439-4f49-babd-36a8b14fd7ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-9b4c-76ab-85d3-6ef86c913b36.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and two chairs near a doorway.",
        "public_id": "019e8993-9b4c-76ab-85d3-6ef86c913b36",
        "storage_key": "property/6767906449163351/019e8993-9b4c-76ab-85d3-6ef86c913b36.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, featuring a stylish round table and two chairs, perfect for intimate gatherings.",
      "link": "",
      "alt_text": "Dining area with a round table and two chairs near a doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92eab061-589b-4a47-aa3a-bafe1d9e50f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-8e0e-742f-82e3-95d10128ce5e.webp",
      "image_media": {
        "alt_text": "Pool table and foosball table in community lounge area",
        "public_id": "019e8993-8e0e-742f-82e3-95d10128ce5e",
        "storage_key": "property/6767906449163351/019e8993-8e0e-742f-82e3-95d10128ce5e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a game of pool or foosball in our spacious community lounge.",
      "link": "",
      "alt_text": "Pool table and foosball table in community lounge area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_78c4a954-48c3-423e-8874-8d078318db56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-9008-7358-94e7-bd3c6d2a08cf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with bar stools.",
        "public_id": "019e8993-9008-7358-94e7-bd3c6d2a08cf",
        "storage_key": "property/6767906449163351/019e8993-9008-7358-94e7-bd3c6d2a08cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stunning kitchen featuring sleek cabinetry, granite countertops, and a spacious island perfect for entertaining. Includes stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_00f595fc-a00d-4a45-9691-54ae23493f59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-8a49-74e0-be1d-647770d55640.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e8993-8a49-74e0-be1d-647770d55640",
        "storage_key": "property/6767906449163351/019e8993-8a49-74e0-be1d-647770d55640.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cook up a storm in this sleek, modern kitchen featuring dark cabinetry, stainless steel appliances, and beautiful granite countertops. A washer and dryer are conveniently located nearby.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0b2a490c-f03a-4dc6-a4df-bde928d6fd1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-8a87-720e-80d3-ccd8f830a1fd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings and a clubhouse.",
        "public_id": "019e8993-8a87-720e-80d3-ccd8f830a1fd",
        "storage_key": "property/6767906449163351/019e8993-8a87-720e-80d3-ccd8f830a1fd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge seating and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings and a clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9750e91c-3fde-45aa-acbc-bcb84a2ffe35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-8d53-7178-a789-7e7220e3ba25.webp",
      "image_media": {
        "alt_text": "Stylish living room with blue sofa, artwork, and modern media console.",
        "public_id": "019e8993-8d53-7178-a789-7e7220e3ba25",
        "storage_key": "property/6767906449163351/019e8993-8d53-7178-a789-7e7220e3ba25.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience elegant living in this beautifully appointed apartment. Features include plush seating, captivating artwork, and a sleek media console for entertainment.",
      "link": "",
      "alt_text": "Stylish living room with blue sofa, artwork, and modern media console.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_400ad8ff-3c1e-47ea-b840-fc1803883193",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-7ebc-711a-9c4e-f9bcda27340a.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and apartment buildings in the background.",
        "public_id": "019e8993-7ebc-711a-9c4e-f9bcda27340a",
        "storage_key": "property/6767906449163351/019e8993-7ebc-711a-9c4e-f9bcda27340a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our community dog park, perfect for your furry friends to play and socialize. Featuring agility equipment and ample green space.",
      "link": "",
      "alt_text": "Dog park with agility equipment and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2da7667a-15d8-4957-98d2-99da81b3ddc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-7625-761f-9d99-62f036bad946.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area with modern apartment buildings in the background.",
        "public_id": "019e8993-7625-761f-9d99-62f036bad946",
        "storage_key": "property/6767906449163351/019e8993-7625-761f-9d99-62f036bad946.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge seating and a shaded pergola area. The perfect spot to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge area with modern apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e934bf16-da50-4b3f-b6f6-aa9fe38dc37e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-749f-702d-b059-bd6863a0e3d0.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with granite countertops.",
        "public_id": "019e8993-749f-702d-b059-bd6863a0e3d0",
        "storage_key": "property/6767906449163351/019e8993-749f-702d-b059-bd6863a0e3d0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this modern apartment bathroom, featuring a sleek vanity, granite countertops, and a clean, refreshing bathtub and shower.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bdb57d1b-48db-42a6-9419-477419f8463d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-7f09-7766-bbf2-9c3bc69ce065.webp",
      "image_media": {
        "alt_text": "Laundry room with white washer and dryer, shelves with baskets, and wall art.",
        "public_id": "019e8993-7f09-7766-bbf2-9c3bc69ce065",
        "storage_key": "property/6767906449163351/019e8993-7f09-7766-bbf2-9c3bc69ce065.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A modern laundry room featuring a white washer and dryer, organized shelving with decorative baskets, and abstract wall art for a stylish touch.",
      "link": "",
      "alt_text": "Laundry room with white washer and dryer, shelves with baskets, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_602db2bc-cef9-4ca3-ad32-8b37f0d0ce51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-7581-72a2-9408-e7188909d32d.webp",
      "image_media": {
        "alt_text": "Modern fitness center with weights, cardio machines, and mirrors.",
        "public_id": "019e8993-7581-72a2-9408-e7188909d32d",
        "storage_key": "property/6767906449163351/019e8993-7581-72a2-9408-e7188909d32d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a wide selection of weights and cardio equipment for a great workout.",
      "link": "",
      "alt_text": "Modern fitness center with weights, cardio machines, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8bfd0c8-b297-4bf5-a77e-4dd46b9558cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-726a-7148-b461-f2fe75f79a25.webp",
      "image_media": {
        "alt_text": "King-size bed with green headboard and decorative pillows, facing a bathroom entrance. Bedroom view.",
        "public_id": "019e8993-726a-7148-b461-f2fe75f79a25",
        "storage_key": "property/6767906449163351/019e8993-726a-7148-b461-f2fe75f79a25.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully appointed bedroom, featuring a plush king-size bed and elegant decor. The adjoining en-suite bathroom offers modern convenience.",
      "link": "",
      "alt_text": "King-size bed with green headboard and decorative pillows, facing a bathroom entrance. Bedroom view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dbe5bbee-5980-43b1-8313-cd9f3009d7c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-5f74-72aa-8dcb-fbac181ce2d0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, adjacent to apartment buildings.",
        "public_id": "019e8993-5f74-72aa-8dcb-fbac181ce2d0",
        "storage_key": "property/6767906449163351/019e8993-5f74-72aa-8dcb-fbac181ce2d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge seating and shaded cabanas. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c49d3b12-e082-4bdc-b49d-84392c070f1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-6ec5-76c7-b60b-f86b6fe998b9.webp",
      "image_media": {
        "alt_text": "Modern living room with green sofa, coffee table, TV, and decorative wall art.",
        "public_id": "019e8993-6ec5-76c7-b60b-f86b6fe998b9",
        "storage_key": "property/6767906449163351/019e8993-6ec5-76c7-b60b-f86b6fe998b9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a plush green sofa, contemporary coffee table, entertainment console, and unique wall decor. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with green sofa, coffee table, TV, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57ae1d11-4f92-4b34-9372-f17ca5caa4fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-6f11-7169-b613-2c9db970706f.webp",
      "image_media": {
        "alt_text": "Lobby with fireplace, seating area, and decorative elements.",
        "public_id": "019e8993-6f11-7169-b613-2c9db970706f",
        "storage_key": "property/6767906449163351/019e8993-6f11-7169-b613-2c9db970706f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Elegant lobby area featuring a fireplace, comfortable seating, and stylish decor.",
      "link": "",
      "alt_text": "Lobby with fireplace, seating area, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_398e76ed-651d-493c-9cb8-c49df3be1afc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-6835-74df-9ae9-b13f9fe95b7d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, community pool, and parking lot.",
        "public_id": "019e8993-6835-74df-9ae9-b13f9fe95b7d",
        "storage_key": "property/6767906449163351/019e8993-6835-74df-9ae9-b13f9fe95b7d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Spacious apartment complex with modern buildings, a sparkling outdoor pool, ample parking, and scenic surroundings.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings, community pool, and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dc8a8e2b-35d3-4b2c-9f00-994ed89dc57e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-509c-70da-9482-dc9e7af5aef7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a wooden pergola and lounge seating.",
        "public_id": "019e8993-509c-70da-9482-dc9e7af5aef7",
        "storage_key": "property/6767906449163351/019e8993-509c-70da-9482-dc9e7af5aef7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge seating and shaded by a beautiful wooden pergola. Perfect for relaxing and socializing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a wooden pergola and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae95da61-3d45-47d4-bf78-b4c37a3a3a80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-5e3c-7108-9b45-a2959143106f.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating and grilling area with tables, chairs, and grills, overlooking apartment buildings.",
        "public_id": "019e8993-5e3c-7108-9b45-a2959143106f",
        "storage_key": "property/6767906449163351/019e8993-5e3c-7108-9b45-a2959143106f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our resident grilling stations and covered patio seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Covered outdoor seating and grilling area with tables, chairs, and grills, overlooking apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_addc0a4c-e229-421b-94e5-3da487700cbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-5705-7782-a2a0-329784714466.webp",
      "image_media": {
        "alt_text": "Corner walk-in closet with multiple shelves and hanging rods.",
        "public_id": "019e8993-5705-7782-a2a0-329784714466",
        "storage_key": "property/6767906449163351/019e8993-5705-7782-a2a0-329784714466.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious corner walk-in closet featuring ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "",
      "alt_text": "Corner walk-in closet with multiple shelves and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6149bf1f-7cf4-44dd-9649-ba4b7b338c97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-517c-74a5-88c5-dd18f27cc984.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019e8993-517c-74a5-88c5-dd18f27cc984",
        "storage_key": "property/6767906449163351/019e8993-517c-74a5-88c5-dd18f27cc984.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a stainless steel refrigerator, microwave, range, and dishwasher, complemented by granite countertops and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_508f8369-5fac-44a8-9c5f-fe75e151b5ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-565d-71ee-a149-feaeb2e6d3f3.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with island and stainless steel appliances, open to living area.",
        "public_id": "019e8993-565d-71ee-a149-feaeb2e6d3f3",
        "storage_key": "property/6767906449163351/019e8993-565d-71ee-a149-feaeb2e6d3f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept apartment featuring a gourmet kitchen with a granite island and sleek stainless steel appliances, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern apartment kitchen with island and stainless steel appliances, open to living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3b598f0-ea9b-4815-8083-6efeeffc9191",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-4f79-71cb-8d1e-63c37c77b16d.webp",
      "image_media": {
        "alt_text": "Treadmills, stair climber, and rowing machine in a modern apartment gym.",
        "public_id": "019e8993-4f79-71cb-8d1e-63c37c77b16d",
        "storage_key": "property/6767906449163351/019e8993-4f79-71cb-8d1e-63c37c77b16d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills, a stair climber, and a rowing machine for residents to enjoy.",
      "link": "",
      "alt_text": "Treadmills, stair climber, and rowing machine in a modern apartment gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f375bb5-9b70-4afc-94a4-b8db183de1c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-4ba3-77de-bb42-4ba9e524c69a.webp",
      "image_media": {
        "alt_text": "Sleek lounge area with a large sectional sofa, coffee tables, and a bar with stools.",
        "public_id": "019e8993-4ba3-77de-bb42-4ba9e524c69a",
        "storage_key": "property/6767906449163351/019e8993-4ba3-77de-bb42-4ba9e524c69a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, featuring comfortable seating and a modern bar perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Sleek lounge area with a large sectional sofa, coffee tables, and a bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_459465aa-e20f-4a0a-b775-17915f636b2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-4897-73af-8510-b649061e67e3.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, dresser, and ceiling fan.",
        "public_id": "019e8993-4897-73af-8510-b649061e67e3",
        "storage_key": "property/6767906449163351/019e8993-4897-73af-8510-b649061e67e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant dresser, and modern ceiling fan, perfect for a relaxing retreat.",
      "link": "",
      "alt_text": "Bedroom with king-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d13e92a7-0fb9-41e0-9726-a4a838fd4e36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e8993-41d3-773c-8bea-af26d3233aca.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet.",
        "public_id": "019e8993-41d3-773c-8bea-af26d3233aca",
        "storage_key": "property/6767906449163351/019e8993-41d3-773c-8bea-af26d3233aca.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A stylish bathroom featuring a granite-top vanity, spacious walk-in closet, and modern fixtures, perfect for your new home.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_fc6e675c8e3ee14f58c48128",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Cafe 290 Manor",
      "poi_type": "Restaurants",
      "poi_address": "11011 US-290, Manor, TX 78653, USA",
      "poi_short_description": "Down-home cafe offering classic breakfast staples and fried fare in a cozy environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-4edc-76b4-8fae-ccf92da59c18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-4edc-76b4-8fae-ccf92da59c18",
        "storage_key": "property/6767906449163351/019f14e5-4edc-76b4-8fae-ccf92da59c18.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://cafe290.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=7610710333461508052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-290-manor",
      "poi_latitude": "30.3483263",
      "poi_longitude": "-97.5584167",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-278-8780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea43-723d-adbb-0f30c4fe6260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea43-723d-adbb-0f30c4fe6260",
        "storage_key": "property/6767906449163351/019f14e5-ea43-723d-adbb-0f30c4fe6260.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJj21-vwTHRIYR1C9emrmsnmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_ec4804459c094253c14a520a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "LA MAREA RESTAURANT & SEAFOOD",
      "poi_type": "Restaurants",
      "poi_address": "116 E Parsons St, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-4651-752c-96cf-9517aef8e473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-4651-752c-96cf-9517aef8e473",
        "storage_key": "property/6767906449163351/019f14e5-4651-752c-96cf-9517aef8e473.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lamarearestaurantandseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1359477281962851739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-marea-restaurant--seafood",
      "poi_latitude": "30.3407068",
      "poi_longitude": "-97.5570305",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 512-580-2480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1-GaufHRIYRm_2bl2LV3RI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d32146e35afefbcb89533417",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Chokdee Thai Cuisine of Manor",
      "poi_type": "Restaurants",
      "poi_address": "11300 US-290, Manor, TX 78653, USA",
      "poi_short_description": "The menu spans curries, noodles, seafood & rice dishes at this relaxed Thai restaurant.",
      "poi_long_description": "The menu spans curries, noodles, seafood & rice dishes at this relaxed Thai restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-418b-765e-af55-bfceebe88b47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-418b-765e-af55-bfceebe88b47",
        "storage_key": "property/6767906449163351/019f14e5-418b-765e-af55-bfceebe88b47.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://chokdee-thai.com/manor?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=5263523420043963386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chokdee-thai-cuisine-of-manor",
      "poi_latitude": "30.3496083",
      "poi_longitude": "-97.5541757",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 512-410-7291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN23mfxvHRIYR-murxqnKC0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_d066333d1833dd07475c4382",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Good Luck Grill",
      "poi_type": "Restaurants",
      "poi_address": "14605 FM973, Manor, TX 78653, USA",
      "poi_short_description": "Comfortable outpost for catfish, fried chicken & other Southern classics, plus a kid-friendly patio.",
      "poi_long_description": "Comfortable outpost for catfish, fried chicken & other Southern classics, plus a kid-friendly patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-439c-74a4-893b-c0fbe0a7ab69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-439c-74a4-893b-c0fbe0a7ab69",
        "storage_key": "property/6767906449163351/019f14e5-439c-74a4-893b-c0fbe0a7ab69.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://goodluckgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15944100894430731009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "good-luck-grill",
      "poi_latitude": "30.3738918",
      "poi_longitude": "-97.528244",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 512-272-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeX-B8zGRIYRARuIu0nTRN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_5e60060fe64bf66cbc1e9b9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Texas Traditional Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "910 N Caldwell St, Manor, TX 78653, USA",
      "poi_short_description": "Down-to-earth joint serving typical BBQ eats, plus American mains such as chicken fried steak.",
      "poi_long_description": "Down-to-earth joint serving typical BBQ eats, plus American mains such as chicken fried steak.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-3b65-7508-9383-b91d9c97380b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-3b65-7508-9383-b91d9c97380b",
        "storage_key": "property/6767906449163351/019f14e5-3b65-7508-9383-b91d9c97380b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7628283985320982574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-traditional-bar-b-q",
      "poi_latitude": "30.3484644",
      "poi_longitude": "-97.556878",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-278-1519",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSYEZNhvHRIYRLrjbRt4b3Wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_3637210d5a6907f0fded6eba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Maxine's Gumbo House",
      "poi_type": "Restaurants",
      "poi_address": "11007 US-290, Manor, TX 78653, USA",
      "poi_short_description": "Casual restaurant serving comfort food with a Cajun twist, including po' boys and crawfish etouffee.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-46fd-711e-a871-0ff838e5cf4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-46fd-711e-a871-0ff838e5cf4b",
        "storage_key": "property/6767906449163351/019f14e5-46fd-711e-a871-0ff838e5cf4b.webp",
        "width": 1280,
        "height": 858
      },
      "poi_business_url": "http://gumbotexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10878477299438553128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maxines-gumbo-house",
      "poi_latitude": "30.348295",
      "poi_longitude": "-97.558683",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-291-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZ8PMbHHRIYRKIgvmncd-JY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_45885537db393b9748c2dda8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Casa Garcia's - Manor",
      "poi_type": "Restaurants",
      "poi_address": "12700 Lexington St Suite 100, Manor, TX 78653, USA",
      "poi_short_description": "Relaxed eatery serving Mexican staples such as enchiladas, burritos, tacos, grilled meats & fajitas.",
      "poi_long_description": "Relaxed eatery serving Mexican staples such as enchiladas, burritos, tacos, grilled meats & fajitas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-4076-760a-a10f-944800813a4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-4076-760a-a10f-944800813a4e",
        "storage_key": "property/6767906449163351/019f14e5-4076-760a-a10f-944800813a4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.casagarcias.com/?y_source=1_MzU5NDYxNDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=18135526054607987557&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casa-garcias---manor",
      "poi_latitude": "30.3508976",
      "poi_longitude": "-97.5569697",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 737-600-8171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzU_Ui-DHRIYRZSPAS9xUrvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_c2c5d14f33bbdc3f478d33b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Grazie! Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "13700 FM973 Bldg D, Manor, TX 78653, USA",
      "poi_short_description": "Casual pizzeria serving Neapolitan-style pies, plus wings and calzones, with vegetarian options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-47c8-709b-8ec4-3770bbae93ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-47c8-709b-8ec4-3770bbae93ac",
        "storage_key": "property/6767906449163351/019f14e5-47c8-709b-8ec4-3770bbae93ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.graziepizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8194155913088062751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grazie-pizzeria",
      "poi_latitude": "30.3610724",
      "poi_longitude": "-97.5327216",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-549-4222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwRHK8fHRIYRH9XHcWN9t3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_f9a14cfeac3c9d266908fbdd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "DoubleDave's Pizzaworks",
      "poi_type": "Restaurants",
      "poi_address": "11828 Ring Dr, Manor, TX 78653, USA",
      "poi_short_description": "Chain counter-serve pizzeria known for its Peproni Rolls & make-your-own pizzas.",
      "poi_long_description": "Chain counter-serve pizzeria known for its Peproni Rolls & make-your-own pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-3bb7-76ea-98c6-8ca961676e98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-3bb7-76ea-98c6-8ca961676e98",
        "storage_key": "property/6767906449163351/019f14e5-3bb7-76ea-98c6-8ca961676e98.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.doubledaves.com/locations/tx/manor/manor?utm_medium=yext&utm_source=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=687880434046463940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doubledaves-pizzaworks",
      "poi_latitude": "30.3477221",
      "poi_longitude": "-97.5410988",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 737-802-3293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTJLmFTHRIYRxO9HN5zXiwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_7618377c6322828e6d99f16c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "12609 US-290, Manor, TX 78653, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-3cf4-700d-80c3-424f0184061e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-3cf4-700d-80c3-424f0184061e",
        "storage_key": "property/6767906449163351/019f14e5-3cf4-700d-80c3-424f0184061e.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/tx/manor/manor/5714?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:manor-tx-5714_pl:locurl_rd:1626",
      "poi_directions_map_url": "https://maps.google.com/?cid=14734934128540478578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "30.3490576",
      "poi_longitude": "-97.5298717",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-275-1191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm8LuawDHRIYRcmxvWIUAfcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_92612140c59e3fe2e5149891",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "11920 US-290 WB, Manor, TX 78653, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-5a9a-75ed-9885-b5a6cea7c4c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-5a9a-75ed-9885-b5a6cea7c4c4",
        "storage_key": "property/6767906449163351/019f14e5-5a9a-75ed-9885-b5a6cea7c4c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chilis.com/locations/us/texas/manor/manor",
      "poi_directions_map_url": "https://maps.google.com/?cid=16747674057333309264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "30.3496986",
      "poi_longitude": "-97.5428281",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 512-967-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3l3NgDHRIYRUH9gedKwa-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_93e042ca56218ddb86eff581",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "12608 Lexington St, Manor, TX 78653, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-5636-75ca-a688-d8090f086fae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-5636-75ca-a688-d8090f086fae",
        "storage_key": "property/6767906449163351/019f14e5-5636-75ca-a688-d8090f086fae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1014254/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16422357472294703724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "30.34965",
      "poi_longitude": "-97.55649",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-585-3771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea43-723d-adbb-0f30c4fe6260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea43-723d-adbb-0f30c4fe6260",
        "storage_key": "property/6767906449163351/019f14e5-ea43-723d-adbb-0f30c4fe6260.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ_dftWBvHRIYRbJKblhzv5-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_ae4a0938f2346b8ce63c1fa5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "El Bandido Suelto",
      "poi_type": "Restaurants",
      "poi_address": "109 E Murray Ave, Manor, TX 78653, USA",
      "poi_short_description": "Salsa, taco, tortilla and torta spot with a picnic area and a trailer theme dishing up birria tacos and noodles. Consommé is also available.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-4edc-76b4-8fae-ca2f2cbed751.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-4edc-76b4-8fae-ca2f2cbed751",
        "storage_key": "property/6767906449163351/019f14e5-4edc-76b4-8fae-ca2f2cbed751.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://elbandidosuelto.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5107686170552907786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-bandido-suelto",
      "poi_latitude": "30.3477953",
      "poi_longitude": "-97.5554791",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-815-2237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcwqZ23HRIYRCjj7q4Il4kY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_4fe315dada49123a5c6c9603",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Prost Alehouse Texas",
      "poi_type": "Restaurants",
      "poi_address": "115 E Main St, Pflugerville, TX 78660, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-600d-7469-8e39-f4aba3b9151a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-600d-7469-8e39-f4aba3b9151a",
        "storage_key": "property/6767906449163351/019f14e5-600d-7469-8e39-f4aba3b9151a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.prostalehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5100773070561703343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prost-alehouse-texas",
      "poi_latitude": "30.440214",
      "poi_longitude": "-97.6198619",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 512-551-2038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVC02zrPRIYRr3W1JhWWyUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_2c30bc3025d3c95cfd6766aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "The Victory Tap",
      "poi_type": "Restaurants",
      "poi_address": "111 E Main St, Pflugerville, TX 78660, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-5c35-72ea-a9a1-6fc36ac6c03e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-5c35-72ea-a9a1-6fc36ac6c03e",
        "storage_key": "property/6767906449163351/019f14e5-5c35-72ea-a9a1-6fc36ac6c03e.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://thevictorytap.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11603309335838487685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-victory-tap",
      "poi_latitude": "30.4402913",
      "poi_longitude": "-97.6200217",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 512-358-6150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea47-7736-9940-e8615074e625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea47-7736-9940-e8615074e625",
        "storage_key": "property/6767906449163351/019f14e5-ea47-7736-9940-e8615074e625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-cRR1QnPRIYRhXSgLV08B6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_2fd70a38e6c1cd8d118fb090",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "11923 US-290, Manor, TX 78653, USA",
      "poi_short_description": "Retail chain selling groceries, electronics, furniture, toys and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-612f-75cc-b6ef-1c8fff43b611.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-612f-75cc-b6ef-1c8fff43b611",
        "storage_key": "property/6767906449163351/019f14e5-612f-75cc-b6ef-1c8fff43b611.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/3169-manor-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4605703150976998370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.3472564",
      "poi_longitude": "-97.5435063",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-651-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea6f-77f9-bda4-79a3e09bac8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea6f-77f9-bda4-79a3e09bac8d",
        "storage_key": "property/6767906449163351/019f14e5-ea6f-77f9-bda4-79a3e09bac8d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk044tTzHRIYR4pvhHp2-6j8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_63e65915eb97750880178dc8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Manor Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "14008 Shadow Glen Blvd #102, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-60d8-7332-aca8-8873ac52e9a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-60d8-7332-aca8-8873ac52e9a0",
        "storage_key": "property/6767906449163351/019f14e5-60d8-7332-aca8-8873ac52e9a0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.manorpharmacycares.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=40823644947239617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-pharmacy",
      "poi_latitude": "30.349954",
      "poi_longitude": "-97.545861",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-642-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-eaa8-71eb-bc7d-24887b4bd6bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-eaa8-71eb-bc7d-24887b4bd6bb",
        "storage_key": "property/6767906449163351/019f14e5-eaa8-71eb-bc7d-24887b4bd6bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVtcBCLHRIYRwVKEh-MIkQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_e5a0f2d386245b1334710557",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "76 Mini Foods Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "10910 US-290, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-684c-75fa-8314-172e93c78dfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-684c-75fa-8314-172e93c78dfc",
        "storage_key": "property/6767906449163351/019f14e5-684c-75fa-8314-172e93c78dfc.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.76super.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16646655125701672392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "76-mini-foods-mart",
      "poi_latitude": "30.3488031",
      "poi_longitude": "-97.5603553",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 512-537-9377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea3b-7761-8c19-fae8df283266.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea3b-7761-8c19-fae8df283266",
        "storage_key": "property/6767906449163351/019f14e5-ea3b-7761-8c19-fae8df283266.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ68c7JDTHRIYRyD3imaPMBOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_17974c808a7b811369074751",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "11209 US-290, Manor, TX 78653, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-5f45-716c-b935-310df61e0363.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-5f45-716c-b935-310df61e0363",
        "storage_key": "property/6767906449163351/019f14e5-5f45-716c-b935-310df61e0363.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/manor/11209-e-hwy-290-41555?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12099215580968236316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "30.3482746",
      "poi_longitude": "-97.5563343",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-739-4669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea3b-7761-8c19-fae8df283266.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea3b-7761-8c19-fae8df283266",
        "storage_key": "property/6767906449163351/019f14e5-ea3b-7761-8c19-fae8df283266.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJtV0_SEbHRIYRHLV7bHcM6ac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_a8baace7cc14664841baa1cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Blake Manor Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "17530 Blake Manor Rd, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-689e-77be-9555-e7e3134eeff2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-689e-77be-9555-e7e3134eeff2",
        "storage_key": "property/6767906449163351/019f14e5-689e-77be-9555-e7e3134eeff2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7844612442545990007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blake-manor-food-mart",
      "poi_latitude": "30.318358",
      "poi_longitude": "-97.5398033",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-272-8388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea68-765b-ba42-23b2c63bd74b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea68-765b-ba42-23b2c63bd74b",
        "storage_key": "property/6767906449163351/019f14e5-ea68-765b-ba42-23b2c63bd74b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Qvu3lvHRIYRdymQNnSp3Ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_7d0e9928cc6ab70b2cb18612",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Apple Express Texaco Gas Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "12401 Tillgang Pass, Manor, TX 78653, USA",
      "poi_short_description": "Gas station featuring breakfast tacos and other quick bites.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-6452-72dc-af43-89d537e03c14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-6452-72dc-af43-89d537e03c14",
        "storage_key": "property/6767906449163351/019f14e5-6452-72dc-af43-89d537e03c14.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.texaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15246083511720266006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apple-express-texaco-gas-station",
      "poi_latitude": "30.34837349999999",
      "poi_longitude": "-97.5634646",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-272-4728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea68-765b-ba42-23b2c63bd74b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea68-765b-ba42-23b2c63bd74b",
        "storage_key": "property/6767906449163351/019f14e5-ea68-765b-ba42-23b2c63bd74b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1lPpQbHRIYRFskGPC34lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_617d3d5eda31b97ec93f7d20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "12300 Harris Branch Pkwy, Manor, TX 78653, USA",
      "poi_short_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_long_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-7044-779a-b6d6-6c8e3960898a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-7044-779a-b6d6-6c8e3960898a",
        "storage_key": "property/6767906449163351/019f14e5-7044-779a-b6d6-6c8e3960898a.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/austin/12300-harris-branch-pkwy/2741551?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5440018518724831000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "30.3693736",
      "poi_longitude": "-97.6137215",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-278-8004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea3b-7761-8c19-fae8df283266.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea3b-7761-8c19-fae8df283266",
        "storage_key": "property/6767906449163351/019f14e5-ea3b-7761-8c19-fae8df283266.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJc4Ej1p3IRIYRGOcjNAXUfks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_b87d0da6a627c0d626f1607d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "12750 Lapoynor St, Manor, TX 78653, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-6bc2-7737-8aa6-23672194e386.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-6bc2-7737-8aa6-23672194e386",
        "storage_key": "property/6767906449163351/019f14e5-6bc2-7737-8aa6-23672194e386.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/tx/manor/6946",
      "poi_directions_map_url": "https://maps.google.com/?cid=11023679581733532676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "30.3357925",
      "poi_longitude": "-97.5597",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-649-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea6f-77f9-bda4-79a3e09bac8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea6f-77f9-bda4-79a3e09bac8d",
        "storage_key": "property/6767906449163351/019f14e5-ea6f-77f9-bda4-79a3e09bac8d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6Z1jqA3HRIYRBDT0ciz6-5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_c26f66b65b91c5a8b2de2bb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Goodwill Central Texas - Shadow Glen Donation Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "14001 Shadow Glen Blvd Bldg. H, Manor, TX 78653, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-713b-7398-9e0d-64f0540f3672.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-713b-7398-9e0d-64f0540f3672",
        "storage_key": "property/6767906449163351/019f14e5-713b-7398-9e0d-64f0540f3672.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.goodwillcentraltexas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6376874364282737694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodwill-central-texas---shadow-glen-donation-center",
      "poi_latitude": "30.3502407",
      "poi_longitude": "-97.5471079",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-272-4435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Z-IshjHRIYRHhRevHI1f1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_cda7606d95da9cccd1269871",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Bluebonnet Trail Elementary",
      "poi_type": "Education",
      "poi_address": "11316 Farmhaven Rd, Austin, TX 78754, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://bte.manorisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559889191336557182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bluebonnet-trail-elementary",
      "poi_latitude": "30.3515378",
      "poi_longitude": "-97.618508",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 512-278-4125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpUjg-H3IRIYRfjrW6C5CsfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_df5c0ee4528173786bcb07b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Decker Middle School",
      "poi_type": "Education",
      "poi_address": "8104 Decker Ln, Austin, TX 78724, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-7202-7138-984a-8a97f2ca172f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-7202-7138-984a-8a97f2ca172f",
        "storage_key": "property/6767906449163351/019f14e5-7202-7138-984a-8a97f2ca172f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.manorisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6549019620449516238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "decker-middle-school",
      "poi_latitude": "30.3105427",
      "poi_longitude": "-97.6213666",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-278-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9X_rDALIRIYRzvr0h6XK4lo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_86fb7725891e30214328497f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Manor Middle School",
      "poi_type": "Education",
      "poi_address": "12900 Gregg Manor Rd, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-7269-779b-b36d-18e2f4bb496f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-7269-779b-b36d-18e2f4bb496f",
        "storage_key": "property/6767906449163351/019f14e5-7269-779b-b36d-18e2f4bb496f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.manorisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2848876178271965784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-middle-school",
      "poi_latitude": "30.3577037",
      "poi_longitude": "-97.5624531",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-278-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcWFkIfzGRIYRWBL5Rso9iSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_d06a2d41e5536b9a5213f916",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Manor Senior High School, Manor ISD",
      "poi_type": "Education",
      "poi_address": "14832 FM973, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-7210-734c-9472-ff277b7c0768.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-7210-734c-9472-ff277b7c0768",
        "storage_key": "property/6767906449163351/019f14e5-7210-734c-9472-ff277b7c0768.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.manorisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=431460459110076345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-senior-high-school-manor-isd",
      "poi_latitude": "30.3824652",
      "poi_longitude": "-97.5310532",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 512-278-4665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIas7M8_HRIYRuQ_iZwDb_AU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_5af7d552cbf4bc993493abce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Manor New Technology High School",
      "poi_type": "Education",
      "poi_address": "10323 US-290, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.manorisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12673137696465798065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-new-technology-high-school",
      "poi_latitude": "30.3448155",
      "poi_longitude": "-97.5734938",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-278-4875",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSx16uqjHRIYRscN0-5YH4K8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_92c380f7900d106d65007ef8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Manor Elementary Early Learning Center",
      "poi_type": "Education",
      "poi_address": "12904 Gregg Manor Rd, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-77e9-759a-b6ca-8a482b9d001d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-77e9-759a-b6ca-8a482b9d001d",
        "storage_key": "property/6767906449163351/019f14e5-77e9-759a-b6ca-8a482b9d001d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.manorisd.net/Domain/12",
      "poi_directions_map_url": "https://maps.google.com/?cid=14275752433003385079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-elementary-early-learning-center",
      "poi_latitude": "30.358586",
      "poi_longitude": "-97.5661537",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-278-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDf8nEP_GRIYR99CVnjOpHcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_b7b2be1cc2048ebb32d84b54",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Blake Manor Elementary School",
      "poi_type": "Education",
      "poi_address": "18010 Blake Manor Rd, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-8ab0-771c-a521-8338c9a30187.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-8ab0-771c-a521-8338c9a30187",
        "storage_key": "property/6767906449163351/019f14e5-8ab0-771c-a521-8338c9a30187.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://blakemanor.manorisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3036380538076106442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blake-manor-elementary-school",
      "poi_latitude": "30.308541",
      "poi_longitude": "-97.5333339",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 512-278-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT1l-h6i4RIYRyo7vDgNkIyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_32cd2c15b3c959da10267399",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Presidential Meadows Elem School",
      "poi_type": "Education",
      "poi_address": "13252 George Bush St, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-96bd-704b-a292-8ea76d8b5912.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-96bd-704b-a292-8ea76d8b5912",
        "storage_key": "property/6767906449163351/019f14e5-96bd-704b-a292-8ea76d8b5912.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://presidentialmeadows.manorisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17575641038661523058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "presidential-meadows-elem-school",
      "poi_latitude": "30.3525647",
      "poi_longitude": "-97.5260639",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-278-4225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0dzjwNTARIYRcpYyqWc46fM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_650bb59aa3bc52732eb90dcd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Pioneer Crossing Elementary School",
      "poi_type": "Education",
      "poi_address": "11300 Samsung Blvd, Austin, TX 78754, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-7cf4-739c-a9a7-a26db1daa539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-7cf4-739c-a9a7-a26db1daa539",
        "storage_key": "property/6767906449163351/019f14e5-7cf4-739c-a9a7-a26db1daa539.webp",
        "width": 1048,
        "height": 1280
      },
      "poi_business_url": "http://pce.manorisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1232640215474638573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-crossing-elementary-school",
      "poi_latitude": "30.3620411",
      "poi_longitude": "-97.640032",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 512-278-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVUYY3fHIRIYR7Q46w743GxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_9b97c11cc5cef06e4e221f2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Oak Meadows Elementary School",
      "poi_type": "Education",
      "poi_address": "5600 Decker Ln, Austin, TX 78724, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-7cb8-73fe-b13f-b583d0b13282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-7cb8-73fe-b13f-b583d0b13282",
        "storage_key": "property/6767906449163351/019f14e5-7cb8-73fe-b13f-b583d0b13282.webp",
        "width": 1280,
        "height": 595
      },
      "poi_business_url": "http://ome.manorisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14552656371258913330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-meadows-elementary-school",
      "poi_latitude": "30.2808057",
      "poi_longitude": "-97.6360776",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 512-278-4175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcSzXoOq3RIYRMnI2y91r9ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5087814ce0febbdf12eef605",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Jennie Lane Park",
      "poi_type": "Entertainment",
      "poi_address": "104 E Rector St, Manor, TX 78653, USA",
      "poi_short_description": "Cozy public space with a playground, a pavilion and exercise equipment plus picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-88af-71fd-b9c7-4c21054ca432.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-88af-71fd-b9c7-4c21054ca432",
        "storage_key": "property/6767906449163351/019f14e5-88af-71fd-b9c7-4c21054ca432.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.cityofmanor.org/page/pw_street_parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=8056532613536334637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jennie-lane-park",
      "poi_latitude": "30.3456431",
      "poi_longitude": "-97.5560455",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-272-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyJSxhrHRIYRLcMuB7qNzm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c1043056cabf17930bd6a299",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Manor Art Park",
      "poi_type": "Entertainment",
      "poi_address": "111 S Lexington St, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-906d-7215-bbb6-ff887771e9b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-906d-7215-bbb6-ff887771e9b1",
        "storage_key": "property/6767906449163351/019f14e5-906d-7215-bbb6-ff887771e9b1.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13041326484521415725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-art-park",
      "poi_latitude": "30.3403589",
      "poi_longitude": "-97.5576104",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 512-272-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVCCdLfHRIYRLfTKfVcZ_LQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f6759e21343f37c96f1336fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Good Luck Grill",
      "poi_type": "Entertainment",
      "poi_address": "14605 FM973, Manor, TX 78653, USA",
      "poi_short_description": "Comfortable outpost for catfish, fried chicken & other Southern classics, plus a kid-friendly patio.",
      "poi_long_description": "Comfortable outpost for catfish, fried chicken & other Southern classics, plus a kid-friendly patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-439c-74a4-893b-c0fbe0a7ab69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-439c-74a4-893b-c0fbe0a7ab69",
        "storage_key": "property/6767906449163351/019f14e5-439c-74a4-893b-c0fbe0a7ab69.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://goodluckgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15944100894430731009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "good-luck-grill",
      "poi_latitude": "30.3738918",
      "poi_longitude": "-97.528244",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 512-272-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea62-74b9-92a8-00638d9c179a",
        "storage_key": "property/6767906449163351/019f14e5-ea62-74b9-92a8-00638d9c179a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeX-B8zGRIYRARuIu0nTRN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_27fdfaf6d62798010e137b95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "The Whiskey Girls Saloon",
      "poi_type": "Entertainment",
      "poi_address": "13700 FM973, Bldg A, Manor, TX 78653, USA",
      "poi_short_description": "Casual, clean bar with pool tables for birthday bashes and watching sports.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-83ff-74bc-a7e6-b66816832119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-83ff-74bc-a7e6-b66816832119",
        "storage_key": "property/6767906449163351/019f14e5-83ff-74bc-a7e6-b66816832119.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.whiskeygirlssaloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15492904083216584150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-whiskey-girls-saloon",
      "poi_latitude": "30.3609775",
      "poi_longitude": "-97.5331745",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-551-9926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea47-7736-9940-e8615074e625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea47-7736-9940-e8615074e625",
        "storage_key": "property/6767906449163351/019f14e5-ea47-7736-9940-e8615074e625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbU3bPHfHRIYR1s1Swy3aAdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_90039c92e0df20646083f207",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Ghost Town Manor Flea Market",
      "poi_type": "Entertainment",
      "poi_address": "14219 Littig Rd, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-958a-7136-9d3f-aa7985778ab4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-958a-7136-9d3f-aa7985778ab4",
        "storage_key": "property/6767906449163351/019f14e5-958a-7136-9d3f-aa7985778ab4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://manorfleamarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4245822263421423438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ghost-town-manor-flea-market",
      "poi_latitude": "30.3332944",
      "poi_longitude": "-97.509501",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea6f-77f9-bda4-79a3e09bac8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea6f-77f9-bda4-79a3e09bac8d",
        "storage_key": "property/6767906449163351/019f14e5-ea6f-77f9-bda4-79a3e09bac8d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz7RkebnBRIYRTs-tbtow7Do",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "flea_market"
    },
    {
      "id": "ec_266263fcc8aa0616fcae8839",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Cinemark Pflugerville 20 and XD",
      "poi_type": "Entertainment",
      "poi_address": "15436 FM1825, Pflugerville, TX 78660, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-94d9-766b-890f-09d02c0eb484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-94d9-766b-890f-09d02c0eb484",
        "storage_key": "property/6767906449163351/019f14e5-94d9-766b-890f-09d02c0eb484.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-pflugerville/cinemark-pflugerville-20-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI4ODAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6861159527495977194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-pflugerville-20-and-xd",
      "poi_latitude": "30.4476635",
      "poi_longitude": "-97.6635669",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 512-989-8535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecbe-70f2-9caf-0ea8b4976c07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecbe-70f2-9caf-0ea8b4976c07",
        "storage_key": "property/6767906449163351/019f14e5-ecbe-70f2-9caf-0ea8b4976c07.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3c203XrFRIYR6kiv_zy8N18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_5675b467e9c04f565439b5e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Lake Pflugerville Park",
      "poi_type": "Entertainment",
      "poi_address": "18216 Weiss Ln, Pflugerville, TX 78660, USA",
      "poi_short_description": "Featuring 7 fishing piers, this park offers swimming, paddling & wind surfing, plus a 3-mile trail.",
      "poi_long_description": "Featuring 7 fishing piers, this park offers swimming, paddling & wind surfing, plus a 3-mile trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-9b68-7653-9fce-50f05a2d8fbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-9b68-7653-9fce-50f05a2d8fbc",
        "storage_key": "property/6767906449163351/019f14e5-9b68-7653-9fce-50f05a2d8fbc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pflugervilletx.gov/337/City-Parks?contentId=e5d77f12-98ee-45ff-8c31-0e6ec1aef14a",
      "poi_directions_map_url": "https://maps.google.com/?cid=16161584212700585800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-pflugerville-park",
      "poi_latitude": "30.4428682",
      "poi_longitude": "-97.566095",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 512-990-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg9OqPFXERIYRSF-UtTZ7SeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_51c34dec84458d57df0f3947",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Spare Time Texas Pflugerville",
      "poi_type": "Entertainment",
      "poi_address": "1724 FM 685, Pflugerville, TX 78660, USA",
      "poi_short_description": "Entertainment venue with bowling, laser tag, axe throwing, and an arcade, plus a restaurant and bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-95fe-735f-b0af-23de6f3229e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-95fe-735f-b0af-23de6f3229e5",
        "storage_key": "property/6767906449163351/019f14e5-95fe-735f-b0af-23de6f3229e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sparetimetexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12634306624618490327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spare-time-texas-pflugerville",
      "poi_latitude": "30.4544394",
      "poi_longitude": "-97.605079",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 512-647-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx390QnvFRIYR1-m_h-8SVq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_3d9624017154ef242c1b1337",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Typhoon Texas Waterpark Austin",
      "poi_type": "Entertainment",
      "poi_address": "18500 TX-130 Service Rd, Pflugerville, TX 78660, USA",
      "poi_short_description": "Sprawling recreation area with swimming pools, water slides & a lazy river, plus fast-food eateries.",
      "poi_long_description": "Sprawling recreation area with swimming pools, water slides & a lazy river, plus fast-food eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-9272-753a-bf64-24c71ee826ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-9272-753a-bf64-24c71ee826ef",
        "storage_key": "property/6767906449163351/019f14e5-9272-753a-bf64-24c71ee826ef.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.typhoontexas.com/austin",
      "poi_directions_map_url": "https://maps.google.com/?cid=1219116366392261744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "typhoon-texas-waterpark-austin",
      "poi_latitude": "30.4622154",
      "poi_longitude": "-97.5974995",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 512-212-7792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx9qFLGnFRIYRcPysRuAr6xA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_fab2a23420d0c589707b09ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Dell Diamond",
      "poi_type": "Entertainment",
      "poi_address": "3400 E Palm Valley Blvd, Round Rock, TX 78665, USA",
      "poi_short_description": "Home of the Round Rock Express, affiliate of the Major League Texas Rangers baseball team.",
      "poi_long_description": "Home of the Round Rock Express, affiliate of the Major League Texas Rangers baseball team.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-a211-73e3-8aab-8dc7d8dcebac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-a211-73e3-8aab-8dc7d8dcebac",
        "storage_key": "property/6767906449163351/019f14e5-a211-73e3-8aab-8dc7d8dcebac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.milb.com/round-rock",
      "poi_directions_map_url": "https://maps.google.com/?cid=16954601638123439540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dell-diamond",
      "poi_latitude": "30.5277278",
      "poi_longitude": "-97.6300626",
      "poi_miles_from_property": "17.4 mi",
      "poi_walking_minutes": "6 hours 21 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 512-255-2255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecc8-737b-81b4-be0fe3b28853.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecc8-737b-81b4-be0fe3b28853",
        "storage_key": "property/6767906449163351/019f14e5-ecc8-737b-81b4-be0fe3b28853.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw47422bQRIYRtIWaTFzYSus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_9bf726bd5300339bc041f057",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "St. David's Emergency Center - Manor",
      "poi_type": "Health and Wellness",
      "poi_address": "10703 US-290, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-9c22-73dc-8e3d-763b155c6bb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-9c22-73dc-8e3d-763b155c6bb9",
        "storage_key": "property/6767906449163351/019f14e5-9c22-73dc-8e3d-763b155c6bb9.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.stdavids.com/locations/st-davids-emergency-center-manor?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14655090214821863957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-davids-emergency-center---manor",
      "poi_latitude": "30.3473989",
      "poi_longitude": "-97.5629936",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 512-747-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXhF65bHRIYRFaLChedWYcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_9386eef1d48281d897294c60",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Texas MedClinic Urgent Care - Manor",
      "poi_type": "Health and Wellness",
      "poi_address": "10104 US-290, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-a2e3-71ce-b6cc-161a1110bea1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-a2e3-71ce-b6cc-161a1110bea1",
        "storage_key": "property/6767906449163351/019f14e5-a2e3-71ce-b6cc-161a1110bea1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasmedclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15353540793406353172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-medclinic-urgent-care---manor",
      "poi_latitude": "30.344606",
      "poi_longitude": "-97.584537",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 512-643-8164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwezyomvHRIYRFG90SwG8EtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_cc97c043a5b90abfe699804e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Manor",
      "poi_type": "Health and Wellness",
      "poi_address": "14008 Shadow Glen Blvd #100, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-a34c-72a1-ab65-9ab0d046d229.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-a34c-72a1-ab65-9ab0d046d229",
        "storage_key": "property/6767906449163351/019f14e5-a34c-72a1-ab65-9ab0d046d229.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/austin/manor?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=583534289313757769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---manor",
      "poi_latitude": "30.3499558",
      "poi_longitude": "-97.5458383",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-514-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXS06AyLHRIYRSXrOLFghGQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e7c6b127baec8c72a6fa377a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Manor Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "14008 Shadow Glen Blvd #102, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-60d8-7332-aca8-8873ac52e9a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-60d8-7332-aca8-8873ac52e9a0",
        "storage_key": "property/6767906449163351/019f14e5-60d8-7332-aca8-8873ac52e9a0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.manorpharmacycares.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=40823644947239617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-pharmacy",
      "poi_latitude": "30.349954",
      "poi_longitude": "-97.545861",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-642-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-eaa8-71eb-bc7d-24887b4bd6bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-eaa8-71eb-bc7d-24887b4bd6bb",
        "storage_key": "property/6767906449163351/019f14e5-eaa8-71eb-bc7d-24887b4bd6bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVtcBCLHRIYRwVKEh-MIkQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_7e33900178f58562f573dc8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11923 US-290, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-a5eb-709a-a09b-e1fbf3bb02f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-a5eb-709a-a09b-e1fbf3bb02f4",
        "storage_key": "property/6767906449163351/019f14e5-a5eb-709a-a09b-e1fbf3bb02f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3169-manor-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13827539090967038944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "30.3470129",
      "poi_longitude": "-97.5437326",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-651-9128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-eaa8-71eb-bc7d-24887b4bd6bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-eaa8-71eb-bc7d-24887b4bd6bb",
        "storage_key": "property/6767906449163351/019f14e5-eaa8-71eb-bc7d-24887b4bd6bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQU4YpyPHRIYR4AvrsopJ5b8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_19697fa2ffe2660bd5eaa71d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "13100 FM973 Bldg. 1, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-a7d9-71e5-b7e3-1a936f7ad091.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-a7d9-71e5-b7e3-1a936f7ad091",
        "storage_key": "property/6767906449163351/019f14e5-a7d9-71e5-b7e3-1a936f7ad091.webp",
        "width": 1195,
        "height": 672
      },
      "poi_business_url": "https://www.heb.com/discover/manor-grand-opening?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=6663826423675420435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "30.351737",
      "poi_longitude": "-97.5387578",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 737-396-0475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-eaa8-71eb-bc7d-24887b4bd6bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-eaa8-71eb-bc7d-24887b4bd6bb",
        "storage_key": "property/6767906449163351/019f14e5-eaa8-71eb-bc7d-24887b4bd6bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq23AmtPHRIYRE_8IbNOqelw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_1ce693c05a6e3105c1a7ee24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11910 US-290 Ste 370, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ac3f-76e2-b20e-89eb0c241fc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-ac3f-76e2-b20e-89eb0c241fc9",
        "storage_key": "property/6767906449163351/019f14e5-ac3f-76e2-b20e-89eb0c241fc9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/manor-tx?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2229584445701817621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "30.3515223",
      "poi_longitude": "-97.5436853",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-884-5415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGelG8yHHRIYRFQXLkj0T8R4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_2a785887c5855f9a74834fd7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "HT Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12421 E, 12421 US-290 SUITE 1, Manor, TX 78653, USA",
      "poi_short_description": "Local gym offering 24-hour access, clean equipment and a childcare area, along with fitness classes and personal training at times.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e3-9334-74e4-9eb6-b7b665acaae0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e3-9334-74e4-9eb6-b7b665acaae0",
        "storage_key": "property/6767906449163351/019f14e3-9334-74e4-9eb6-b7b665acaae0.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://www.htfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2680144292534599937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ht-fitness",
      "poi_latitude": "30.3486479",
      "poi_longitude": "-97.5325907",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-272-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7zPTR_HRIYRAcFQtwjJMSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0cd3d1dc14bf832c30ac2562",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "HOTWORX - Manor, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "12836 US-290 Suite 700, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-abe5-71bd-b4ce-89c6db740889.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-abe5-71bd-b4ce-89c6db740889",
        "storage_key": "property/6767906449163351/019f14e5-abe5-71bd-b4ce-89c6db740889.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.hotworx.net/studio/manor-george-bush",
      "poi_directions_map_url": "https://maps.google.com/?cid=12563221880517553929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---manor-tx",
      "poi_latitude": "30.3505053",
      "poi_longitude": "-97.526185",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-365-0064",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf_wrRqPHRIYRCe-pzryHWa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_0585444f6738f52c25a2bf1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "East Side Balance - Pilates Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "16512 Moonlit Path, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-b52f-74f1-bcef-ae35fddbf581.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-b52f-74f1-bcef-ae35fddbf581",
        "storage_key": "property/6767906449163351/019f14e5-b52f-74f1-bcef-ae35fddbf581.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.eastsidebalance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8900140577712068505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-side-balance---pilates-studio",
      "poi_latitude": "30.296203",
      "poi_longitude": "-97.5572148",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 512-698-1890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea4a-72f2-abe3-4be49bbc8c4d",
        "storage_key": "property/6767906449163351/019f14e5-ea4a-72f2-abe3-4be49bbc8c4d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCUUfAxLKRIYRmVeRUbOmg3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_9ff9c4a4f29659509c6b09ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Timmermann Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12616 Skimmer Run, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ba3a-71ea-b925-eca4d13ef413.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-ba3a-71ea-b925-eca4d13ef413",
        "storage_key": "property/6767906449163351/019f14e5-ba3a-71ea-b925-eca4d13ef413.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofmanor.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15693421710409219856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timmermann-park",
      "poi_latitude": "30.343005",
      "poi_longitude": "-97.5374128",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 512-272-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGSlww8vHRIYRED9Y9-U7ytk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_dcb3c14a6e783370815bb0d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Jennie Lane Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "104 E Rector St, Manor, TX 78653, USA",
      "poi_short_description": "Cozy public space with a playground, a pavilion and exercise equipment plus picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-88af-71fd-b9c7-4c21054ca432.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-88af-71fd-b9c7-4c21054ca432",
        "storage_key": "property/6767906449163351/019f14e5-88af-71fd-b9c7-4c21054ca432.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.cityofmanor.org/page/pw_street_parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=8056532613536334637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jennie-lane-park",
      "poi_latitude": "30.3456431",
      "poi_longitude": "-97.5560455",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 512-272-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyJSxhrHRIYRLcMuB7qNzm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e8316181644b744dbae52240",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Ben Fisher Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 W Carrie Manor St, Manor, TX 78653, USA",
      "poi_short_description": "Park offering a playground, picnic tables, and a basketball court, plus a bike path.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-bb71-77e8-9dea-5179f1418add.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-bb71-77e8-9dea-5179f1418add",
        "storage_key": "property/6767906449163351/019f14e5-bb71-77e8-9dea-5179f1418add.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://parks.traviscountytx.gov/find-a-park/ben-fisher",
      "poi_directions_map_url": "https://maps.google.com/?cid=2506216695019339226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ben-fisher-park",
      "poi_latitude": "30.3395186",
      "poi_longitude": "-97.5645036",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 512-272-5561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcbgMEwnHRIYR2v3HPM7exyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_bda5fbf03822731eaffc3ee6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "East Metropolitan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18706 Blake Manor Rd, Manor, TX 78653, USA",
      "poi_short_description": "Recreational area provides a disc golf course, fishing piers, a pool, sports fields & a playground.",
      "poi_long_description": "Recreational area provides a disc golf course, fishing piers, a pool, sports fields & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e3-e0e6-776e-aff1-ba3e71b329bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e3-e0e6-776e-aff1-ba3e71b329bc",
        "storage_key": "property/6767906449163351/019f14e3-e0e6-776e-aff1-ba3e71b329bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parks.traviscountytx.gov/parks/east-metro",
      "poi_directions_map_url": "https://maps.google.com/?cid=5707945123409353988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-metropolitan-park",
      "poi_latitude": "30.2892328",
      "poi_longitude": "-97.5246437",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 512-854-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgyLglcq4RIYRBN08BtmxNk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_27a22de0cdb8c607845a6243",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Greenbury Village Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Maxa Dr, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-b535-71ca-99fc-d5b173f84f44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-b535-71ca-99fc-d5b173f84f44",
        "storage_key": "property/6767906449163351/019f14e5-b535-71ca-99fc-d5b173f84f44.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614636185968989494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenbury-village-park",
      "poi_latitude": "30.3509205",
      "poi_longitude": "-97.5299776",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT2w1AizHRIYRNlXcSnrn8Lw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_73b42ed3c28b40307e17a355",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Bell Farms Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12905 Ring Dr, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-c41b-7752-b5a1-02f21314ae78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-c41b-7752-b5a1-02f21314ae78",
        "storage_key": "property/6767906449163351/019f14e5-c41b-7752-b5a1-02f21314ae78.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17039058567439378111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell-farms-park",
      "poi_latitude": "30.342898",
      "poi_longitude": "-97.5269246",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-272-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZVtFN9PHRIYRv-ZMg33lduw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_04074f1d0fc949f26261e83d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Bell Farms Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12905 Ring Dr, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-c478-7422-866b-3ce061b1533b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-c478-7422-866b-3ce061b1533b",
        "storage_key": "property/6767906449163351/019f14e5-c478-7422-866b-3ce061b1533b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17039058567439378111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell-farms-park",
      "poi_latitude": "30.342898",
      "poi_longitude": "-97.5269246",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-272-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZVtFN9PHRIYRv-ZMg33lduw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_605c316865b10ac3e6710d7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Carriage Hills Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-b544-705f-a3f4-b5282e715638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-b544-705f-a3f4-b5282e715638",
        "storage_key": "property/6767906449163351/019f14e5-b544-705f-a3f4-b5282e715638.webp",
        "width": 1020,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16408418054369521250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carriage-hills-park",
      "poi_latitude": "30.3389852",
      "poi_longitude": "-97.5234231",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMd0py-7BRIYRYi7N8EhptuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2f0587801e18591de4667625",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Woodlands Park Nature Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9F93+Q7, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-cd5e-7206-a9a1-e7d0c8872bf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-cd5e-7206-a9a1-e7d0c8872bf6",
        "storage_key": "property/6767906449163351/019f14e5-cd5e-7206-a9a1-e7d0c8872bf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9652482964325099226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodlands-park-nature-trail",
      "poi_latitude": "30.3693794",
      "poi_longitude": "-97.546791",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea74-71ed-8eae-23f25183c6d1",
        "storage_key": "property/6767906449163351/019f14e5-ea74-71ed-8eae-23f25183c6d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZL-9eLHRIYR2mYbcR2C9IU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ef525b215f0f8ab587cbb636",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Presidential Heights",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14224 Jeannette Rankin Rd, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-cbdf-724f-b449-87a31c919954.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-cbdf-724f-b449-87a31c919954",
        "storage_key": "property/6767906449163351/019f14e5-cbdf-724f-b449-87a31c919954.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16610051486051540131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "presidential-heights",
      "poi_latitude": "30.3644429",
      "poi_longitude": "-97.5139427",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3-T9fwHBRIYRoxwNn9LBguY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_9a8e9d1dc3be479f89df1662",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Park & Ride Manor",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 W Carrie Manor St, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://capmetro.org/park-ride/manor-park-ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=3252591607340242126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park--ride-manor",
      "poi_latitude": "30.3397889",
      "poi_longitude": "-97.5590442",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 512-474-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecdc-769c-b6e0-851f18204e32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecdc-769c-b6e0-851f18204e32",
        "storage_key": "property/6767906449163351/019f14e5-ecdc-769c-b6e0-851f18204e32.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJyataQg7HRIYRzpTuetWGIy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_8002c0adb08fb9cd63e9939e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Park & Ride Manor",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 W Carrie Manor St, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://capmetro.org/park-ride/manor-park-ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=3252591607340242126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park--ride-manor",
      "poi_latitude": "30.3397889",
      "poi_longitude": "-97.5590442",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 512-474-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecdc-769c-b6e0-851f18204e32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecdc-769c-b6e0-851f18204e32",
        "storage_key": "property/6767906449163351/019f14e5-ecdc-769c-b6e0-851f18204e32.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJyataQg7HRIYRzpTuetWGIy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_73ac5ed6c6962905041eecd5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Manor Crossing",
      "poi_type": "Transportation & Transit",
      "poi_address": "11910 US-290, Manor, TX 78653, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-c47b-731f-b159-c9bde602f548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-c47b-731f-b159-c9bde602f548",
        "storage_key": "property/6767906449163351/019f14e5-c47b-731f-b159-c9bde602f548.webp",
        "width": 576,
        "height": 1280
      },
      "poi_business_url": "https://theretailconnection.net/properties/manor-crossing-manor-tx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6723836519536861092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-crossing",
      "poi_latitude": "30.35053479999999",
      "poi_longitude": "-97.5432214",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea6f-77f9-bda4-79a3e09bac8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea6f-77f9-bda4-79a3e09bac8d",
        "storage_key": "property/6767906449163351/019f14e5-ea6f-77f9-bda4-79a3e09bac8d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJrRoWPwDHRIYRpB_LqrDdT10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_65b46cade7172b26c4ed8f30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Elgin Parks and Recreation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "361 State Hwy 95, Elgin, TX 78621, USA",
      "poi_short_description": "Recreational venue offering a basketball court, as well as programs and events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-c6c5-7438-82d5-04ab13c017c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-c6c5-7438-82d5-04ab13c017c6",
        "storage_key": "property/6767906449163351/019f14e5-c6c5-7438-82d5-04ab13c017c6.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://www.elgintexas.gov/239/Recreation-Programming",
      "poi_directions_map_url": "https://maps.google.com/?cid=7626108618772564160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elgin-parks-and-recreation-center",
      "poi_latitude": "30.3575057",
      "poi_longitude": "-97.3815078",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 37 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 512-285-6434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsQh4axnrRIYRwMh7SGJh1Wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_5d1aa1bc0c45377f8f9076df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Delco Activity Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4601 Pecan Brook Dr, Austin, TX 78724, USA",
      "poi_short_description": "Venue for sports, including wrestling matches, that also operates as a Covid-19 vaccination hub.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-d0f3-77fe-8648-cef6d52746cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-d0f3-77fe-8648-cef6d52746cd",
        "storage_key": "property/6767906449163351/019f14e5-d0f3-77fe-8648-cef6d52746cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.austinisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4735847029470617565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delco-activity-center",
      "poi_latitude": "30.3175034",
      "poi_longitude": "-97.6605446",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 512-866-6434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2XoKks7JRIYR3V8vHsgbuUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "ec_2232ed6d232e4f28b6862c7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Expo Center Park & Ride - CapMetro",
      "poi_type": "Transportation & Transit",
      "poi_address": "7001 Decker Ln, Austin, TX 78724, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-d0fb-71fd-9ab8-2d9837279bd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-d0fb-71fd-9ab8-2d9837279bd4",
        "storage_key": "property/6767906449163351/019f14e5-d0fb-71fd-9ab8-2d9837279bd4.webp",
        "width": 1280,
        "height": 838
      },
      "poi_business_url": "https://www.capmetro.org/park-ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=4709218108933924493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "expo-center-park--ride---capmetro",
      "poi_latitude": "30.2942514",
      "poi_longitude": "-97.6253764",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecdc-769c-b6e0-851f18204e32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecdc-769c-b6e0-851f18204e32",
        "storage_key": "property/6767906449163351/019f14e5-ecdc-769c-b6e0-851f18204e32.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJlWPpGgC3RIYRjebXaOuAWkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_45ef7f4dc7b93b9830c8acf7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Austin-Bergstrom International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Presidential Blvd, Austin, TX 78719, USA",
      "poi_short_description": "Austin-area airport featuring regular live-music performances & numerous artworks.",
      "poi_long_description": "Austin-area airport featuring regular live-music performances & numerous artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-d363-730d-9f87-e37dff6cf061.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-d363-730d-9f87-e37dff6cf061",
        "storage_key": "property/6767906449163351/019f14e5-d363-730d-9f87-e37dff6cf061.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.austintexas.gov/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=2064896756044015464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-bergstrom-international-airport",
      "poi_latitude": "30.194085",
      "poi_longitude": "-97.6710889",
      "poi_miles_from_property": "16.8 mi",
      "poi_walking_minutes": "6 hours 4 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 512-530-2242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecee-778f-b00e-78ef2dbfebfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecee-778f-b00e-78ef2dbfebfb",
        "storage_key": "property/6767906449163351/019f14e5-ecee-778f-b00e-78ef2dbfebfb.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJRf9KizuxRIYRaCfcyaj8pxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_1aed8fd555ce0983365074e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "363 Shady Ln, Austin, TX 78702, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-d46c-70ef-8906-00ff70168111.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-d46c-70ef-8906-00ff70168111",
        "storage_key": "property/6767906449163351/019f14e5-d46c-70ef-8906-00ff70168111.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/bus/austin-tx/austin-eastside-bus-plaza?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=448900343737329614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "30.2516609",
      "poi_longitude": "-97.6979091",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06MUvhfKRIYRzqcD-HvQOgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_42440f084809afebc4810e37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Tesla Giga Texas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Tesla Rd, Austin, TX 78725, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-d916-710d-84a0-338946554701.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-d916-710d-84a0-338946554701",
        "storage_key": "property/6767906449163351/019f14e5-d916-710d-84a0-338946554701.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tesla.com/giga-texas",
      "poi_directions_map_url": "https://maps.google.com/?cid=8044261432942276074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tesla-giga-texas",
      "poi_latitude": "30.2248156",
      "poi_longitude": "-97.619548",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 512-516-8177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJedYjPy3RIYR6i3mJif1om8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_a09bb09cdeb404b65f944d4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Circuit of The Americas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9201 Circuit of the Americas Blvd, Del Valle, TX 78617, USA",
      "poi_short_description": "Besides the U.S. Grand Prix, this 3.4-mile racetrack hosts concerts in its amphitheater.",
      "poi_long_description": "Besides the U.S. Grand Prix, this 3.4-mile racetrack hosts concerts in its amphitheater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-db21-770a-ae95-9ad167553287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-db21-770a-ae95-9ad167553287",
        "storage_key": "property/6767906449163351/019f14e5-db21-770a-ae95-9ad167553287.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://circuitoftheamericas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10009294002508390637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circuit-of-the-americas",
      "poi_latitude": "30.1327391",
      "poi_longitude": "-97.6404102",
      "poi_miles_from_property": "19.3 mi",
      "poi_walking_minutes": "7 hours 0 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 512-301-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-epS0TqwRIYR7eD1H90n6Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "ec_4a19f97d7199462c04dc2bba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Austin-Bergstrom International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3600 Presidential Blvd, Austin, TX 78719, USA",
      "poi_short_description": "Austin-area airport featuring regular live-music performances & numerous artworks.",
      "poi_long_description": "Austin-area airport featuring regular live-music performances & numerous artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-da51-7770-9aaf-e60636f8434a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-da51-7770-9aaf-e60636f8434a",
        "storage_key": "property/6767906449163351/019f14e5-da51-7770-9aaf-e60636f8434a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.austintexas.gov/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=2064896756044015464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-bergstrom-international-airport",
      "poi_latitude": "30.194085",
      "poi_longitude": "-97.6710889",
      "poi_miles_from_property": "16.8 mi",
      "poi_walking_minutes": "6 hours 4 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 512-530-2242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecee-778f-b00e-78ef2dbfebfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecee-778f-b00e-78ef2dbfebfb",
        "storage_key": "property/6767906449163351/019f14e5-ecee-778f-b00e-78ef2dbfebfb.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJRf9KizuxRIYRaCfcyaj8pxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_26348e593fcaf4a0f8d7beac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Samsung Austin Semiconductor",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12100 Samsung Blvd, Austin, TX 78754, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-df0e-703e-9dc2-60d516ff1d8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-df0e-703e-9dc2-60d516ff1d8a",
        "storage_key": "property/6767906449163351/019f14e5-df0e-703e-9dc2-60d516ff1d8a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://semiconductor.samsung.com/sas",
      "poi_directions_map_url": "https://maps.google.com/?cid=5596601739214204469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "samsung-austin-semiconductor",
      "poi_latitude": "30.3756106",
      "poi_longitude": "-97.637115",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 512-672-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdae1pcHIRIYRNS4yN6Efq00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_a9269ad4ee796e0092307fc0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Dell Technologies - Round Rock 5",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Dell Way, Round Rock, TX 78682, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-e0fe-77b8-b089-e7ed320d1a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-e0fe-77b8-b089-e7ed320d1a3a",
        "storage_key": "property/6767906449163351/019f14e5-e0fe-77b8-b089-e7ed320d1a3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dell.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11183683824276853971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dell-technologies---round-rock-5",
      "poi_latitude": "30.4886027",
      "poi_longitude": "-97.6705225",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-289-3355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBStWESrORIYR09RNOi9tNJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_ff9a018083d39595a6dad605",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "The University of Texas at Austin Main Building (MAI)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "110 Inner Campus Drive, Austin, TX 78712, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-e231-745d-8b45-f73ed1061a36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-e231-745d-8b45-f73ed1061a36",
        "storage_key": "property/6767906449163351/019f14e5-e231-745d-8b45-f73ed1061a36.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.utexas.edu/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=4722211475644395459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-austin-main-building-mai",
      "poi_latitude": "30.2863291",
      "poi_longitude": "-97.7393046",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 512-471-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ea44-720a-bcf2-3af4d39054a6",
        "storage_key": "property/6767906449163351/019f14e5-ea44-720a-bcf2-3af4d39054a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjW9sIp21RIYRw68OWFGqiEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_846c95fa05c286ec328aeb62",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Ascension Seton Medical Center Austin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 W 38th St, Austin, TX 78705, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-e22e-7628-8b54-14c3e2f49e5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-e22e-7628-8b54-14c3e2f49e5e",
        "storage_key": "property/6767906449163351/019f14e5-e22e-7628-8b54-14c3e2f49e5e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/texas/txaus/austin-ascension-seton-medical-center-austin?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1039491115513651059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-seton-medical-center-austin",
      "poi_latitude": "30.3052081",
      "poi_longitude": "-97.7464296",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 512-324-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecf8-70e6-968c-cc52af30db7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecf8-70e6-968c-cc52af30db7f",
        "storage_key": "property/6767906449163351/019f14e5-ecf8-70e6-968c-cc52af30db7f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44CyyYbKRIYRc59df6kDbQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_2be1de98d58b3eb10044ea28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "St. David's Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "919 E 32nd St, Austin, TX 78705, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-e4e9-73ff-b9aa-f5964adc3716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-e4e9-73ff-b9aa-f5964adc3716",
        "storage_key": "property/6767906449163351/019f14e5-e4e9-73ff-b9aa-f5964adc3716.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.stdavids.com/locations/st-davids-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6088668428792741394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-davids-medical-center",
      "poi_latitude": "30.2898575",
      "poi_longitude": "-97.7260089",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 512-544-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecf8-70e6-968c-cc52af30db7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecf8-70e6-968c-cc52af30db7f",
        "storage_key": "property/6767906449163351/019f14e5-ecf8-70e6-968c-cc52af30db7f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJg3bS4Y21RIYREr5TRa1Lf1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_b00884bdadfedb12827d6974",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "St. David's Round Rock Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 Round Rock Ave, Round Rock, TX 78681, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-e4e9-73ff-b9aa-fbd8fbc45bdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-e4e9-73ff-b9aa-fbd8fbc45bdf",
        "storage_key": "property/6767906449163351/019f14e5-e4e9-73ff-b9aa-fbd8fbc45bdf.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.stdavids.com/locations/st-davids-round-rock-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=16432499809723635143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-davids-round-rock-medical-center",
      "poi_latitude": "30.5104905",
      "poi_longitude": "-97.7140137",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 16 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 512-341-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecf8-70e6-968c-cc52af30db7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecf8-70e6-968c-cc52af30db7f",
        "storage_key": "property/6767906449163351/019f14e5-ecf8-70e6-968c-cc52af30db7f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVVimz7SRIYRx1VAioP3C-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_8603e376369cff55951efc4a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "generator",
      "poi_name": "Baylor Scott & White Medical Center – Round Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 University Blvd, Round Rock, TX 78665, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-e60a-745d-9e43-8eb25e21e516.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-e60a-745d-9e43-8eb25e21e516",
        "storage_key": "property/6767906449163351/019f14e5-e60a-745d-9e43-8eb25e21e516.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/round-rock?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-9717898",
      "poi_directions_map_url": "https://maps.google.com/?cid=8655198573725511372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-medical-center--round-rock",
      "poi_latitude": "30.5632925",
      "poi_longitude": "-97.6849952",
      "poi_miles_from_property": "18.7 mi",
      "poi_walking_minutes": "6 hours 58 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 512-509-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14e5-ecf8-70e6-968c-cc52af30db7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-ecf8-70e6-968c-cc52af30db7f",
        "storage_key": "property/6767906449163351/019f14e5-ecf8-70e6-968c-cc52af30db7f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4huqEXRRIYRzG5g3z5xHXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_04afc5ed-33a2-4cac-a7a7-e0ae91eda4fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_47d3e1fd-f78e-4b3a-92b4-f4bbd1e47f3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_14e0a18d-1720-483c-a05b-db564159aadf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_49fee9f9-4743-48df-b31b-40366eb1f06c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_567999ea-2c7a-410a-9f48-67492dfe7eec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_79b556bf-8930-40e3-ad44-4a77614ad784",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_37cd21ce-82a7-4a28-bcf7-b1c0cd1eef68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_efb0a293be6a76d57eafd6d3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Property is amazing and staff is great! I worked with Noah to lease my apartment and he was informative and punctual. Cant recommend this property enough.  ",
      "date": "false",
      "title": "Band new and gorgeous "
    },
    {
      "id": "ec_46630725ab43c0568acb72d3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Been working with Ricky at this new place.  Did a hard hat tour which was kind of cool and I really liked the place.  Moving down to Austin for a job at Tesla and he made this very easy, and it really close to work.  You can even see downtown from my unit which is cool.  The dog park and pet wash area would be the best for me!  ",
      "date": "false",
      "title": "Gonna work at Tesla and this place is very close"
    },
    {
      "id": "ec_85e784653ad20d15958bca6f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "I have been working with the guys in this complex and have been very impressed with how they handle themselves.  I have had a lot of questions and sometimes call a few times a day, but they are always friendly and patient with me.  I am moving to Austin from the northeast and have not been able to visit but they are more than happy to send me videos and have kept me up to date on the progress of my new unit.  \nLooking forward to getting moved not only to a warmer climate but also to a place where they want to help you.  \n",
      "date": "false",
      "title": "Love how patient these guys are!"
    },
    {
      "id": "ec_94107be0bab98fb726d538e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "excellent place to live tranquil and safely, the apartment is in perfect condition.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d7c2e4fca55bf4e5c213809b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "The property is beautiful! I toured with Mason and he was patient with all the many questions I had about the apartment. Easy access to i-35, making it a quick drive downtown.",
      "date": "false",
      "title": "Great location, open availability!"
    },
    {
      "id": "ec_6e1de30b0c1175d6a996d8e2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Awesome place with friendly neighbors and staff. Huge pool too!",
      "date": "false",
      "title": "Awesome home!"
    },
    {
      "id": "ec_df5becb9b934200dbc8bd080",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "The property is beautiful! I love the pool area. The leasing office team is awesome! Always helpful.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_adbb9b66524c91ec1036fd3b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "I recently visited and took a look at this complex, its hot here in Texas and people can be un-willing to help.  The guy that showed me around was really nice and made sure he and I both had water and didn't spend to much time outside while still showing me all the stuff I wanted to see.  I ended up leasing and am looking forward to living there.  ",
      "date": "false",
      "title": "Happy to help!"
    },
    {
      "id": "ec_09eb7753ffcacba0a3491656",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "The staff is so helpful, and the facilities are beautiful. We moved from 6 hours away and the transition was seamless with the help of the amazing folks working in the offices. Response time is great, community is wonderful, I really can't recommend Alta Blue Goose enough!",
      "date": "false",
      "title": "Best place to live in Manor!"
    },
    {
      "id": "ec_9ecfbc72402c13022f6adfc8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "4",
      "name": "false",
      "text": "Beautiful community, professional and welcoming staff, and responsive maintenance.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_f97dbda0b7a3572170726903",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Love that the quality of the facilities is so good and I feel good about the residents I share the community with.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_2cb73464213a580161a5e7f0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "The community is in a great location and quiet.  The staff is always professional, knowledgeable and kind.  The amenities are excellent!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a1de135e83b60342bebdd299",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Great community with beautiful modern apartments and gorgeous amenities!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4cd4a37484fbb3e406d4e872",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Recently had a tour with Mason and Ray (shadowing) this weekend. They both were very welcoming, friendly, professional and informative. After applying Mason and Noah has answered all questions and concerns that I may have had, making this first experience a smooth transition. Very excited about moving to this beautiful community!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_f58319ae48bb333978167950",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Been living here for 3 months and everything is great! Neighborhood is quiet, the apartments are clean and well kept. The staff are very nice and always helpful.",
      "date": "false",
      "title": "Great staff! Great apartments!"
    },
    {
      "id": "ec_59158108905d2270f9b021a9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Alta Blue Goose is a unique complex I lived in since then. Professional staff with more respect and humanity when talking to people. I recommend relatives and friends even other people I know or I don't know to join this community. They will not be disappointed.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_2c73fd32b7c05c10a6f61b15",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Alta Blue Goose is the first and ever complex I have lived in for long. All staff,  from the leasing office to the field staff, they are all awesome. Polite, helpful and for most advisors to their customers when needed. I love Alta Blue Goose Apartment.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ba70e313966b3bcae9d1d103",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "It’s a beautiful community. The public spaces are always kept clean. The office staff are always helpful and polite. Mason has been a great help. The apartment itself is great. I love the finishes and appliances they used. The office is offers community events which is a nice option. I love the pool area too!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_31282ec94db429204fcdb2dd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "I’d like to say I’ve moved into Alta about a week ago, and they allowed me to move in prior to my original move in date so there were bound to be a few things that didn’t work right, with that being said the maintenance crew worked very fast and professionally to get everything in working order! My thanks go out to the crew!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_f5cb7ba9af050566823becfd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "I am extremely pleased that I chose Alta Blue Goose to be my new residence. I am confident that retail establishments will open: in the meantime my brand new apartment, the friendly and supportive staff, the amenities that are provided and the community get-togethers that management hosts are sufficient off-sets to compensate for having to drive an extra mile to shop for my groceries!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b6e0417e2968ddc65cc32325",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "I can't recommend Alta Blue Goose enough! I moved here from out of state, so my entire leasing experience was virtual, but so seamless. The apartment is beautiful and the staff are very nice :)",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0ac1bc101516da70cbb0f7b2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Very lovely and cozy establishment! It's very quiet and my neighbors are very respectful. I feel heard by the staff whenever I have an issue and they are quick to respond.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_daaecc8cbde50ecee5104495",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "4",
      "name": "false",
      "text": "Excellent apartments, in good condition, all the amenities are always clean.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_93b605e289332fc707bbdbc8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "4",
      "name": "false",
      "text": "Alta is a good property in terms of maintaining property cleanliness. Staff is personable.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_fdd086227011889a462354b8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "They are so kind, professional, they listen to their residents, Safe and clean area all the time, they have amazing services. The maintenance system is fast and effective 100% recommended. You can feel security and tranquility in the area.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a8cf0dcb32f999eaf33cc5eb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Management and maintenance are phenomenal. Super quick and efficient.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_80e2175a192a126bc67462a1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Alta Blue Goose is the  best apartment I've lived in since. The most important think with this complex, once you ask for any assistance, whatever tool of communication we use, their staff is flexible and intervenes accordingly. Big up to the entire team. Last but not less, the security of residents and their properties is a priority.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4ba1298c153a6d3c5891f08c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Living at Alta Blue Goose is an awesome experience in every regard, you can check every box on you sheet",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_521324e80770e466552af7da",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "4",
      "name": "false",
      "text": "Making my move to TX not knowing anyone or hardly anything was definitely scary! Alta blue goose staff definitely worked all around to make this move a bit less scary! A quite complex with quality amenities for me and my pup!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_deea3260f8ead3f9908fefca",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "The staff is incredible nice. Mede me feel at home. Brand new apartments, I moved twice within the same complex and it is very satisfying to find brand new appliances. I recommend it.",
      "date": "false",
      "title": "I love this place pretty much"
    },
    {
      "id": "ec_1c2dae17ae3db5f6aa6605e0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "I love living here. I love being the first in the unit. It has been a year and I’ve renewed. The easy access off the highway is perfect if you work in any of surrounding areas. Only downside are walls are super thin and you can hear everything, even the highway if you choose a highway facing unit. \n\nLeasing staff have been great at accommodating my needs.",
      "date": "false",
      "title": "Love living here!"
    },
    {
      "id": "ec_fc3d5512bf4e3ec65de08080",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "Great spacious gym .. \nThe pool is always jumping and super clean ..\nGreat job…",
      "date": "false",
      "title": "Feels like home "
    },
    {
      "id": "ec_39f9c0502925721fca5d6ca5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "rating": "5",
      "name": "false",
      "text": "What really stands out to me, though, is the excellent customer service. The leasing office staff are super friendly and attentive, and they made the move-in process quick and easy. They took the time to make sure I had everything I needed to settle in. Plus, the maintenance team is always available and fast to address any questions or issues.\n\nThe community here is fantastic too, with residents who are friendly and respectful, and the location is ideal — close to [mention any nearby amenities like restaurants, parks, or public transportation].\n\nI couldn’t be happier with my new home and would highly recommend EighyOne10 Blue Goose  to anyone looking for a comfortable, well-managed, and peaceful living environment.",
      "date": "false",
      "title": "Wonderful New Home!"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_0adae4a2-96a1-431d-b4cd-e0a34bd77d37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019d02f5-e537-746f-af07-9d7b9f1eca41.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Stylish living room with a plush blue sectional sofa and modern kitchen counter with bar stools.",
        "public_id": "019d02f5-e537-746f-af07-9d7b9f1eca41",
        "storage_key": "property/6767906449163351/019d02f5-e537-746f-af07-9d7b9f1eca41.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR, 2BA - 1,112SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2MYDNDrBSnx"
    },
    {
      "id": "custom_4565efd9-e43a-4db4-86b8-e65beefd702b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019d02f5-e870-711e-aed5-6d2c650c4088.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a green sofa, coffee table, and a large TV. Kitchen visible in the background.",
        "public_id": "019d02f5-e870-711e-aed5-6d2c650c4088",
        "storage_key": "property/6767906449163351/019d02f5-e870-711e-aed5-6d2c650c4088.webp",
        "width": 984,
        "height": 553
      },
      "virtual_tour_title": "1BR, 1BA - 723SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FiADR9AuqGM"
    },
    {
      "id": "custom_84e0c248-bb6a-4ad0-9681-e6bd9206e4fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f14c2-79fd-7149-9923-9c344b477a15.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-79fd-7149-9923-9c344b477a15",
        "storage_key": "property/6767906449163351/019f14c2-79fd-7149-9923-9c344b477a15.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "EightyOne10 Blue Goose | Community Tour!",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/K_cdSzv5Ro4"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-adfb-756a-9fed-4e76cbcf29cf",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "eightyone10-blue-goose",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351"
    },
    {
      "lead_collector_id": "0198aa46-ae5f-71d9-91fa-04ce772a7302",
      "lead_source": "FACEBOOK_ADS",
      "name": "eightyone10-blue-goose",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351"
    },
    {
      "lead_collector_id": "0198aa46-aec2-703f-b733-1db886c20d5e",
      "lead_source": "LANDING_PAGE",
      "name": "eightyone10-blue-goose",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "studio-apartments-for-rent-manor-tx-8110-blue-goose",
      "search_query": "Studio Apartments For Rent In Manor TX",
      "category": "Floorplan",
      "h1_title": "Studio Apartments For Rent In Manor TX at EightyOne10 Blue Goose",
      "h2_subtitle": "Discover modern living in our stylish and high-tech studio apartments. Conveniently located near major highways and close to Austin, your new home awaits.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious studio apartments for rent in Manor, TX, designed with modern and sophisticated features. Each studio apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. Enjoy cooking in a kitchen equipped with granite countertops, stainless steel appliances, and a dishwasher. Relax in spacious bedrooms with walk-in closets and hardwood floors. Our community is located just north of Wildhorse Ranch, near the 290 and 130 highways, providing easy access to Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring quality education for residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Studio Apartments For Rent In Manor TX",
      "seo_description": "Discover modern studio apartments for rent in Manor, TX at EightyOne10 Blue Goose. Enjoy luxury living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-manor-tx-eightyone-ten",
      "search_query": "One Bedroom Apartments For Rent In Manor TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Manor TX at EightyOne10 Blue Goose",
      "h2_subtitle": "Experience luxury living in our modern and high-tech one-bedroom apartments. Located near major highways and close to Austin, your perfect home is here.",
      "page_copy": "EightyOne10 Blue Goose offers exquisite one bedroom apartments for rent in Manor, TX, featuring modern and sophisticated amenities. Each one-bedroom apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher, making meal prep a breeze. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | One Bedroom Apartments For Rent In Manor TX",
      "seo_description": "Find luxurious one bedroom apartments for rent in Manor, TX at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and easy access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-manor-tx-8110-bg",
      "search_query": "Two Bedrooms Apartments For Rent In Manor TX",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Manor TX at EightyOne10 Blue Goose",
      "h2_subtitle": "Enjoy spacious and modern living in our high-tech two-bedroom apartments. Conveniently located near major highways and close to Austin, your ideal home awaits.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious two bedrooms apartments for rent in Manor, TX, designed with modern and sophisticated features. Each two-bedroom apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher, perfect for culinary enthusiasts. Relax in large bedrooms with walk-in closets and hardwood floors. Our community is conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, providing easy access to Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Two Bedrooms Apartments For Rent In Manor TX",
      "seo_description": "Discover luxurious two bedrooms apartments for rent in Manor, TX at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-manor-tx-8110-bg",
      "search_query": "Three Bedrooms Apartments For Rent In Manor TX",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In Manor TX at EightyOne10 Blue Goose",
      "h2_subtitle": "Experience spacious and luxurious living in our high-tech three-bedroom apartments. Conveniently located near major highways and close to Austin, your dream home is here.",
      "page_copy": "EightyOne10 Blue Goose offers exceptional three bedrooms apartments for rent in Manor, TX, featuring modern and sophisticated amenities. Each three-bedroom apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is designed with granite countertops, stainless steel appliances, and a dishwasher, making it perfect for family meals. Enjoy large bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Three Bedrooms Apartments For Rent In Manor TX",
      "seo_description": "Find luxurious three bedrooms apartments for rent in Manor, TX at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and easy access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pool-at-eightyone",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pool at EightyOne10 Blue Goose",
      "h2_subtitle": "Discover luxury living with a pool and modern amenities. Conveniently located near major highways and close to Austin, your perfect home awaits.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent near me with pool, designed with modern and sophisticated features. Our community amenities include a sparkling pool, fitness center, clubhouse, and lounge, ensuring you have everything you need for a comfortable lifestyle. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent Near Me with Pool",
      "seo_description": "Find luxurious apartments for rent near me with pool at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center at EightyOne10 Blue Goose",
      "h2_subtitle": "Experience luxury living with a state-of-the-art fitness center and modern amenities. Conveniently located near major highways and close to Austin, your ideal home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent near me with fitness center, designed with modern and sophisticated features. Our community amenities include a state-of-the-art fitness center, sparkling pool, clubhouse, and lounge, ensuring you have everything you need for a healthy and active lifestyle. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find luxurious apartments for rent near me with fitness center at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-gameroom-at-8110",
      "search_query": "Apartments For Rent Near Me with Gameroom",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Gameroom at EightyOne10 Blue Goose",
      "h2_subtitle": "Enjoy luxury living with a fun gameroom and modern amenities. Conveniently located near major highways and close to Austin, your perfect home awaits.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent near me with gameroom, designed with modern and sophisticated features. Our community amenities include a fun gameroom, sparkling pool, fitness center, and stylish lounge, ensuring you have everything you need for a comfortable and entertaining lifestyle. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent Near Me with Gameroom",
      "seo_description": "Find luxurious apartments for rent near me with gameroom at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-st-davids-medical",
      "search_query": "Apartments For Rent In Manor TX Near St. David's Medical Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near St. David's Medical Center",
      "h2_subtitle": "Experience luxury living close to St. David's Medical Center. Conveniently located near major highways and Austin, your ideal home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near St. David's Medical Center, part of St. David's HealthCare which provides leading hospitals throughout Central Texas. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and St. David's Medical Center. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near St. David's Medical Center",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near St. David's Medical Center at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-ascension-seton",
      "search_query": "Apartments For Rent In Manor TX Near Ascension Seton Medical Center Austin",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near Ascension Seton Medical Center Austin",
      "h2_subtitle": "Discover luxury living close to Ascension Seton Medical Center Austin. Conveniently located near major highways and Austin, your perfect home awaits.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near Ascension Seton Medical Center Austin, a full-service hospital with a Level IV Trauma Center and 24/7 emergency care. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and Ascension Seton Medical Center Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near Ascension Seton Medical Center Austin",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near Ascension Seton Medical Center Austin at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-pediatric-care",
      "search_query": "Apartments For Rent In Manor TX Near Pediatric Care of Austin",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near Pediatric Care of Austin",
      "h2_subtitle": "Discover luxury living close to Pediatric Care of Austin. Conveniently located near major highways and Austin, your perfect home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near Pediatric Care of Austin, a clinic founded in 1983 by Dr. Rodolfo Barrera. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and Pediatric Care of Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near Pediatric Care of Austin",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near Pediatric Care of Austin at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-austin-college",
      "search_query": "Apartments For Rent In Manor TX Near Austin Community College: Riverside Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near Austin Community College: Riverside Campus",
      "h2_subtitle": "Experience luxury living close to ACC Riverside Campus. Conveniently located near major highways and Austin, your ideal home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near Austin Community College: Riverside Campus, a forward-thinking and technologically advanced campus since 1984. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and ACC Riverside Campus. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near Austin Community College: Riverside Campus",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near Austin Community College: Riverside Campus at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-acc-northridge",
      "search_query": "Apartments For Rent In Manor TX Near Austin Community College: Northridge Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near Austin Community College: Northridge Campus",
      "h2_subtitle": "Discover luxury living close to ACC Northridge Campus. Conveniently located near major highways and Austin, your perfect home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near Austin Community College: Northridge Campus, known for its beautiful outdoor study spots and proximity to Walnut Creek Greenbelt and Austin FC's Q2 Stadium. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and ACC Northridge Campus. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near Austin Community College: Northridge Campus",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near Austin Community College: Northridge Campus at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-manor-tx-near-university-of-texas",
      "search_query": "Apartments For Rent In Manor TX Near The University of Texas at Austin",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near The University of Texas at Austin",
      "h2_subtitle": "Experience luxury living close to The University of Texas at Austin. Conveniently located near major highways and Austin, your ideal home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near The University of Texas at Austin. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and The University of Texas at Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near The University of Texas at Austin",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near The University of Texas at Austin at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-austin-community",
      "search_query": "Apartments For Rent In Manor TX Near Austin Community College: Highland Business Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near Austin Community College: Highland Business Center",
      "h2_subtitle": "Discover luxury living close to ACC Highland Business Center. Conveniently located near major highways and Austin, your perfect home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near Austin Community College: Highland Business Center. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and ACC Highland Business Center. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near Austin Community College: Highland Business Center",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near Austin Community College: Highland Business Center at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-hyde-park-schools",
      "search_query": "Apartments For Rent In Manor TX Near Hyde Park Schools",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near Hyde Park Schools",
      "h2_subtitle": "Discover luxury living close to Hyde Park Schools. Conveniently located near major highways and Austin, your perfect home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near Hyde Park Schools. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and Hyde Park Schools. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near Hyde Park Schools",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near Hyde Park Schools at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-austin-discovery-school",
      "search_query": "Apartments For Rent In Manor TX Near Austin Discovery School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near Austin Discovery School",
      "h2_subtitle": "Experience luxury living close to Austin Discovery School. Conveniently located near major highways and Austin, your ideal home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near Austin Discovery School, a dynamic learning environment that prioritizes academic rigor and community values. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and Austin Discovery School. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near Austin Discovery School",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near Austin Discovery School at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-harmony-school",
      "search_query": "Apartments For Rent In Manor TX Near Harmony School of Science - Austin",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near Harmony School of Science - Austin",
      "h2_subtitle": "Discover luxury living close to Harmony School of Science - Austin. Conveniently located near major highways and Austin, your perfect home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near Harmony School of Science - Austin, a free public charter school serving grades PK-5th. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and Harmony School of Science - Austin. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near Harmony School of Science - Austin",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near Harmony School of Science - Austin at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-brentwood-christian",
      "search_query": "Apartments For Rent In Manor TX Near Brentwood Christian School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near Brentwood Christian School",
      "h2_subtitle": "Experience luxury living close to Brentwood Christian School. Conveniently located near major highways and Austin, your ideal home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near Brentwood Christian School, an outstanding academic institution known for its excellence in fine arts, athletics, and education. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and Brentwood Christian School. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near Brentwood Christian School",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near Brentwood Christian School at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163351",
      "source": "custom",
      "page_item_url": "apartments-for-rent-manor-tx-near-st-francis-school",
      "search_query": "Apartments For Rent In Manor TX Near St. Francis School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Manor TX Near St. Francis School",
      "h2_subtitle": "Discover luxury living close to St. Francis School. Conveniently located near major highways and Austin, your perfect home is here.",
      "page_copy": "EightyOne10 Blue Goose offers luxurious apartments for rent in Manor, TX near St. Francis School. Our modern and sophisticated community features studio, one-, two-, and three-bedroom apartments with high-tech amenities. Each apartment includes Wi-Fi, in-unit washer/dryer, air conditioning, and heating. The kitchen is equipped with granite countertops, stainless steel appliances, and a dishwasher. Enjoy spacious bedrooms with walk-in closets and hardwood floors. Conveniently located just north of Wildhorse Ranch, near the 290 and 130 highways, our community provides easy access to Austin and St. Francis School. Managed by American Landmark, EightyOne10 Blue Goose is in the Manor Independent attendance zone, ensuring a quality living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, apartment buildings in the background.",
        "public_id": "019f6c0e-71bc-7338-a224-0ff2ef6ae779",
        "storage_key": "property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multifamily property building with lush landscaping and a paved walkway.",
        "public_id": "019f6c0e-7b84-763a-a080-e95425557080",
        "storage_key": "property/6767906449163351/019f6c0e-7b84-763a-a080-e95425557080.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "EightyOne10 Blue Goose | Apartments For Rent In Manor TX Near St. Francis School",
      "seo_description": "Find luxurious apartments for rent in Manor, TX near St. Francis School at EightyOne10 Blue Goose. Enjoy modern living with high-tech features and convenient access to Austin.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4251"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "6981683509"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2a\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2a\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5383927"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P3RPZX8H"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "21798739084"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "11f1e149a7c885d2"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8epmlok4v6d"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/49662362-7042-41d0-b673-420b09022f37"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "737-283-9991"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik8zcUhvditnRFN0WHZyZ1NoYXpmL2c9PSIsInZhbHVlIjoiTzA4VFFGemVFc1JjMkUxYVNjZkxCZz09IiwibWFjIjoiNzcxNGE1MmJjZjE0OGJmYWY0ODIyOWNiOTk5NDVmZmI0MTcwOWUxNzdhOTU2N2NmZDAyNmFhNDc4MmRiNDZhMiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "4251",
  "custom_repli_id": "6981683509",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2a\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2a\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5383927",
  "custom_google_gtm_id": "GTM-P3RPZX8H",
  "custom_rollout_phase": "4",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "21798739084",
  "custom_knock_community_id": "11f1e149a7c885d2",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8epmlok4v6d",
  "custom_self_guided_tour_url": "https://selftournow.com/property/49662362-7042-41d0-b673-420b09022f37",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "737-283-9991",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik8zcUhvditnRFN0WHZyZ1NoYXpmL2c9PSIsInZhbHVlIjoiTzA4VFFGemVFc1JjMkUxYVNjZkxCZz09IiwibWFjIjoiNzcxNGE1MmJjZjE0OGJmYWY0ODIyOWNiOTk5NDVmZmI0MTcwOWUxNzdhOTU2N2NmZDAyNmFhNDc4MmRiNDZhMiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "2c0edaac-261e-451c-aa35-efcc23f19535",
  "custom_audioeye_site_hash": "df756c4a49c409e3edde0abf26261df5"
};

export const generatedAt = '2026-11-03T20:26:09.773Z';
